/* eslint-disable jsx-a11y/anchor-is-valid */
import clsx from 'clsx'
import React, {useState, useEffect} from 'react'
import {KTSVG} from '../../../_metronic/helpers'
import {getLayout, ILayout, LayoutSetup, useLayout} from '../../../_metronic/layout/core'
import Form from 'react-bootstrap/Form'
import Button from 'react-bootstrap/Button'
import Modal from 'react-bootstrap/Modal'
import {Link, useNavigate} from 'react-router-dom'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import FloatingLabel from 'react-bootstrap/FloatingLabel'
import {useTranslation, initReactI18next} from 'react-i18next'
import {
  getDetail,
  reject,
  approve,
  revision,
  resubmitFindoc,
  getCustomer,
  getBankKey,
  getComment,
  postComment,
  updateValid,
  getAccesses,
  downloadSKPP,
  syncFromSAP,
} from '../../../api/modules/findoc'
import {getFindocTypes, getIncoterm, getTOPAnper} from '../../../api/modules/getdatalist'
import {useIntl} from 'react-intl'
import {PageTitle} from '../../../_metronic/layout/core'
import Country from '../component/DataCountry.json'
import CustomUseEffect from '../component/CustomUseEffect'
import axios from 'axios'
import swal from 'sweetalert'
import Pagination from '../component/Pagination'
import i18next from 'i18next'
import CurrencyInput from 'react-currency-input-field'
import {Spinner} from 'react-bootstrap'
import DatePicker from 'react-datepicker'
import 'react-datepicker/dist/react-datepicker.css'
import InputGroup from 'react-bootstrap/InputGroup'
import {deleteFile, getFile, create} from '../../../api/modules/file'
import {PopoverText} from '../../../components/Popover/Popover'
import {TableBrowseBankKey} from './TableBrowseBankKey'
import {useAppSelector} from '../../../redux/hooks'
import {financialDocsSelector} from '../../../redux/slices/financialDocsSlices'
import {TableBrowseCustomer} from './TableBrowseCustomer'
import {customerSelector} from '../../../redux/slices/customerSlices'
import {appSelector} from '../../../redux/slices/appSlices'
import {HakAkses} from '../../../components/mikro/getHakAkses'
import {MultiSelect} from 'react-multi-select-component'
import {getRoleFlagList} from '../../../api/modules/master-data/master_2'
import {authSelector} from 'src/redux/slices/authSlices'
import dateformat from 'src/utils/dateformat'
import {CheckSameIDAttachment} from 'src/components/mikro/CheckSameIDAttachment'
import { InputFile } from 'src/app/components/InputFile'
import { handleDownloadAttachment } from 'src/app/helpers/file'

const FinancialDetail: React.FC = () => {
  const {roleId} = useAppSelector(authSelector)
  const {filterBankKey} = useAppSelector(financialDocsSelector)
  const {filter: filterCustomer} = useAppSelector(customerSelector)
  const intl = useIntl()
  const navigate = useNavigate()
  const [btnLoading, setBtnLoading] = useState(false)
  const hakAkses = HakAkses()
  const [showReject, setShowReject] = useState(false)
  const [showApprove, setShowApprove] = useState(false)
  const [showRevision, setShowRevision] = useState(false)
  const [showComment, setShowComment] = useState(false)
  const [comment, setComment] = useState<any>('')
  const [fullcomment, setFullcomment] = useState<any>([])
  const [loading, setLoading] = useState(false)
  const lang = i18next.language
  const [showUpload, setShowUpload] = useState(false)
  const [allFile, setAllFiles] = useState<any[]>([])
  const [dataType, setDataType] = useState('')
  const [namaFile, setNamaFile] = useState('')
  const [description, setDescription] = useState('')
  const [isPrivate, setIsPrivate] = useState(false)
  const [idItem, setIDItem] = useState(sessionStorage.getItem('id'))
  const [accesses, setAccesses] = useState<any>()
  const [fullRole, setFullRole] = useState<any[]>([])
  const [receiptDate, setReceiptDate] = useState<any>('')
  const [lastDateBol, setLastDateBol] = useState<any>('')
  const [presentationDate, setPresentationDate] = useState<any>('')
  const [openingDate, setOpeningDate] = useState<any>('')
  const [roleUser, setRoleUser] = useState('')
  const [findocTypes, setFindocTypes] = useState<any[]>([])
  const [fileName, setFileName] = useState('')
  const [downloadingSKPP, setDownloadingSKPP] = useState(false)
  const [loadingBtnSync, setLoadingBtnSync] = useState(false)


  useEffect(() => {
    const temp = JSON.parse(localStorage.getItem('credential-decoded')!)
    setCustCode(temp?.customer_code)
    const role = () => {
      const role: any = localStorage.getItem('role-flag')
      setRoleUser(role)
    }

    const getAccessMenu = async () => {
      const res = await getAccesses(roleId)
      setAccesses(res.data.data)
    }

    const getAllRoleList = async () => {
      const res = await getRoleFlagList()
      setFullRole(res.data.data)
    }

    const getFindocTypeList = async () => {
      const res = await getFindocTypes()
      setFindocTypes(res.data.data)
    }


    getAccessMenu()
    role()
    getData()
    getAllRoleList()
    getFindocTypeList()
  }, [])

  const removeStorage = () => {
    localStorage.removeItem('credential')
    localStorage.removeItem('credential-decoded')
    localStorage.removeItem('cust-code')
    sessionStorage.removeItem('id')
    sessionStorage.removeItem('po')
    localStorage.removeItem('token')
    localStorage.removeItem('role-flag')
    localStorage.removeItem('dist')
    localStorage.removeItem('cust-group')
    sessionStorage.removeItem('SI_ID')
    localStorage.removeItem('namaUser')
    localStorage.removeItem('username')
    localStorage.removeItem('name')
    localStorage.removeItem('access')
    localStorage.removeItem('accesses')
    localStorage.removeItem('cust-grup')
    localStorage.removeItem('email')
    sessionStorage.removeItem('kid')
    sessionStorage.removeItem('order-detail-id')
    localStorage.removeItem('role-id')
    localStorage.removeItem('sip')
    localStorage.removeItem('user-id')
    localStorage.removeItem('token')
    sessionStorage.removeItem('amandemen')
    localStorage.removeItem('cus-grup')
    localStorage.removeItem('idNews')
    sessionStorage.removeItem('jbp')
    sessionStorage.removeItem('jbp-id')
    localStorage.removeItem('role-id')
    localStorage.removeItem('sales-organization')
  }

  const ambilAttachment = async (id: any) => {
    const res = await getFile('findoc', id, localStorage.getItem('credential')!)
    handleShowAttachment(res.data.data)
  }

  const getSKPP = async (no_skpp: any) => {
      setDownloadingSKPP(true)
      downloadSKPP(no_skpp)
        .then((res: any) => {
          window.open(`${res?.request?.responseURL}?token=${localStorage.getItem('token')}`)
        })
        .finally(() => setDownloadingSKPP(false))
        .catch((err: any) => {
          swal({
            title: t(err?.response?.data?.message || 'Download Gagal, Silahkan Hubungi Admin!'),
            icon: 'error',
          })
        })
  }

  const handleShowAttachment = (data: any) => {
    let tmp: any[] = []
    let idUser = localStorage?.getItem('user-id')
    data.forEach((item: any) => {
      if (item.private) {
        if (hakAkses?.attachment) {
          return tmp.push(item)
        } else if (idUser == item.user_id) {
          return tmp.push(item)
        } else {
        }
      } else {
        return tmp.push(item)
      }
    })
    setAllFiles(tmp)
  }

  const removeFileState = () => {
    setFiles({file: null})
    setNamaFile('')
    setDescription('')
    setDataType('')
    setIsPrivate(false)
  }

  const clearInputUpload = () => {
    const input1 = document.getElementById('uploadketerangan') as HTMLInputElement
    input1.value = ''
    const input2 = document.getElementById('upload') as HTMLInputElement
    input2.value = ''
    const inputPrivate = document.getElementById('isPrivate') as HTMLInputElement
    inputPrivate.checked = false
    // const input3 = document.getElementById("uploadnama") as HTMLInputElement
    // input3.value = ''
    // const input4 = document.getElementById("uploadjenis") as HTMLInputElement
    // input4.value = t('Select file type')
  }

  const handleUpload = async (id: any) => {
    setBtnLoading(true)
    let temparray: any[] = []
    if (tempRole.length > 0) {
      tempRole.forEach((data: any) => {
        temparray.push(data.value)
      })
    }
    let file = files.file
    let formdata = new FormData()
    formdata.append('file_r', file!)
    formdata.append('name', namaFile!)
    formdata.append('description', description!)
    formdata.append('attach_parent', id!)
    formdata.append('file_type', dataType)
    formdata.append('private', isPrivate.toString())
    formdata.append('roles', JSON.stringify(temparray))
    formdata.append('credentials', localStorage.getItem('credential')!)
    // console.log(formdata)
    await create('findoc', formdata)
      .then((res) => {
        if (!res.data.error) {
          ambilAttachment(id)
          swal({
            title: `${t('document uploaded successfully')}`,
            icon: 'success',
          })
          removeFileState()
          clearInputUpload()
        } else {
          swal({
            title: t(res.data.message),
            icon: 'error',
          })
        }
      })
      .catch(function (error) {
        if (error) {
          swal({
            title: t(error.response.data.message),
            icon: 'error',
          })
        }
      })
      .finally(() => {
        setBtnLoading(false)
      })
  }

  const deleteAttachment = async (id: any) => {
    swal({
      title: `${t('Are you sure?')}`,
      icon: 'warning',
      buttons: [`${t('Tidak')}`, `${t('Yes')}`],
      dangerMode: true,
    }).then(async (del) => {
      if (del) {
        await deleteFile(id)
          .then(() => {
            swal({
              closeOnClickOutside: false,
              title: t('Dokumen Berhasil Dihapus'),
              icon: 'success',
            })
            ambilAttachment(idItem)
          })
          .catch((error) => {
            swal({
              title: error.response.data,
              icon: 'error',
            })
          })
      }
    })
  }

  const Approve = async () => {
    setBtnLoading(true)
    let temp = currency
    if (negara == 'ID') temp = 'IDR'
    else temp = 'USD'
    let payload = {}
    let tempcust = customerID
    let tempcust2 = customer
    if (!ship) {
      tempcust = ''
      tempcust2 = ''
    } else {
      tempcust = customerID
      tempcust2 = customer
    }
    if (jenisFindoc == 'skbdn') {
      payload = {
        customer_ship_to: tempcust,
        customer_ship_to_desc: tempcust2,
        bank_name: bank,
        bank_key: bankKey,
        negara: negara,
        finance_comment: comment,
        negara_desc: negaraDesc,
        currency: temp,
        nilai: parseFloat(nilai),
        validity_date_from: dari,
        validity_date_to: berlaku,
        incoterm_id: incoterm,
        incoterm2_id: incoterm2,
        allowance: uang,
        delivery_deadline: batas,
        top_id: TOP,
        ship_to: ship,
        findoc_type: jenisFindoc,
        type_skbdn: skbn,
        lang: lang,
        tgl_findoc: finDate,
        description: keterangan,
        findoc_desc: findocDesc,
        num_findoc: extnoFindoc,
        receipt_date: receiptDate,
        last_date_bol: lastDateBol,
        presentation_date: presentationDate,
        opening_date: openingDate,
      }
    } else {
      payload = {
        customer_ship_to: tempcust,
        customer_ship_to_desc: tempcust2,
        bank_name: bank,
        bank_key: bankKey,
        negara: negara,
        finance_comment: comment,
        negara_desc: negaraDesc,
        currency: temp,
        nilai: parseFloat(nilai),
        validity_date_from: dari,
        validity_date_to: berlaku,
        incoterm_id: incoterm,
        incoterm2_id: incoterm2,
        allowance: uang,
        delivery_deadline: batas,
        top_id: TOP,
        ship_to: ship,
        findoc_type: jenisFindoc,
        num_findoc: extnoFindoc,
        tgl_findoc: finDate,
        description: keterangan,
        findoc_desc: findocDesc,
        lang: lang,
        receipt_date: receiptDate,
        last_date_bol: lastDateBol,
        presentation_date: presentationDate,
        opening_date: openingDate,
      }
    }

    if (status == 5) {
      await updateValid(sessionStorage.getItem('id'), payload)
        .then((res) => {
          if (!res.data.error) {
            swal({
              title: `${t('Findoc Berhasil Dirubah')}`,
              icon: 'success',
            }).then((response) => {
              setShowApprove(false)
              navigate('/financial')
            })
          }
        })
        .catch(function (error) {
          if (error.response) {
            swal({
              title: `${t(error.response.data.message)}`,
              icon: 'error',
            })
          }
        })
        .finally(() => {
          setBtnLoading(false)
        })
    } else {
      await approve(sessionStorage.getItem('id'), payload)
        .then((res) => {
          if (!res.data.error) {
            swal({
              title: `${t('Findoc Berhasil Disetujui')}`,
              icon: 'success',
            }).then((response) => {
              setShowApprove(false)
              navigate('/financial')
            })
          }
        })
        .catch(function (error) {
          if (error.response) {
            swal({
              title: `${t(error.response.data.message)}`,
              icon: 'error',
            })
          }
        })
        .finally(() => {
          setBtnLoading(false)
        })
    }
  }

  const Reject = async () => {
    setBtnLoading(true)
    await reject(sessionStorage.getItem('id'), {reason: rejectNote})
      .then((res) => {
        if (!res.data.error) {
          swal({
            title: `${t('Findoc Berhasil Ditolak')}`,
            icon: 'success',
          }).then((response) => {
            setShowReject(false)
            navigate('/financial')
          })
        }
      })
      .catch(function (error) {
        if (error.response) {
          swal({
            title: `${t(error.response.data.message)}`,
            icon: 'error',
          })
        }
      })
      .finally(() => {
        setBtnLoading(false)
      })
  }

  const Revision = async () => {
    setBtnLoading(true)
    await revision(sessionStorage.getItem('id'), {reason: revisionNote})
      .then((res) => {
        if (!res.data.error) {
          swal({
            title: `${t('Findoc Berhasil Revisi')}`,
            icon: 'success',
          }).then((response) => {
            setShowRevision(false)
            navigate('/financial')
          })
        }
      })
      .catch(function (error) {
        if (error.response) {
          swal({
            title: `${t(error.response.data.message)}`,
            icon: 'error',
          })
        }
      })
      .finally(() => {
        setBtnLoading(false)
      })
  }

  const createFindoc = async () => {
    setBtnLoading(true)
    let file = files.file
    let formdata = new FormData()
    const ckbox = document.getElementById('ckbox-hardcopy') as HTMLInputElement
    let hardcopy = 'false'
    if (ckbox != null)
      if (ckbox.checked) hardcopy = 'true'
      else hardcopy = 'false'

    const ckbox2 = document.getElementById('ckbox-ship') as HTMLInputElement
    let ship = 'false'
    if (ckbox2 != null)
      if (ckbox2.checked) ship = 'true'
      else ship = 'false'

    if (file == null || file == 'null') {
      formdata.append('file', '')
    } else {
      formdata.append('file', file!)
    }

    if (roleUser == 'null') {
      formdata.append('sales_org_code', produsencode!)
      formdata.append('findoc_type', jenisFindoc!)
      if (jenisFindoc == 'skbdn') formdata.append('type_skbdn', skbn!)

      formdata.append('num_findoc', extnoFindoc!)
      formdata.append('findoc_desc', findocDesc)
      formdata.append('tgl_findoc', tanggalFindoc!)
      formdata.append('description', keterangan!)
      formdata.append('no_skpp', skpp)
      formdata.append('sector_id', sektor)
      formdata.append('lang', lang)
      if (tempComment.length < 1) formdata.append('comment', '[]')
      else formdata.append('comment', JSON.stringify(tempComment))
      formdata.append('credentials', localStorage.getItem('credential')!)
    } else {
      formdata.append('findoc_type', jenisFindoc!)
      formdata.append('sales_org_code', produsencode!)
      if (jenisFindoc == 'skbdn') formdata.append('type_skbdn', skbn!)

      formdata.append('num_findoc', extnoFindoc!)
      formdata.append('tgl_findoc', tanggalFindoc!)
      formdata.append('bank_name', bank!)
      formdata.append('bank_key', bankKey!)
      formdata.append('negara', negara!)
      formdata.append('negara_desc', negaraDesc!)
      formdata.append('sector_id', sektor)

      if (negaraDesc == 'Indonesia') formdata.append('currency', 'IDR')
      else formdata.append('currency', 'USD'!)

      formdata.append('nilai', String(nilai!))
      formdata.append('validity_date_from', dari!)
      formdata.append('validity_date_to', berlaku!)
      formdata.append('incoterm_id', incoterm!)
      formdata.append('incoterm2_id', incoterm2!)
      formdata.append('allowance', uang!)
      formdata.append('delivery_deadline', batas!)
      formdata.append('top_id', TOP!)
      formdata.append('findoc_name', namaFindoc)
      formdata.append('findoc_desc', findocDesc)
      formdata.append('send_hard_copy', hardcopy)
      formdata.append('ship_to', ship)
      formdata.append('description', keterangan!)
      formdata.append('no_skpp', skpp)
      formdata.append('lang', lang)
      if (tempComment.length < 1) formdata.append('comment', '[]')
      else formdata.append('comment', JSON.stringify(tempComment))
      formdata.append('credentials', localStorage.getItem('credential')!)
    }

    await resubmitFindoc(getID, formdata)
      .then((response) => {
        if (!response.data.error)
          swal({
            title: `${t('Findoc Berhasil Revisi')}`,
            icon: 'success',
          }).then(() => {
            navigate('/financial')
          })
        else
          swal({
            title: `${t('Error')}`,
            icon: 'error',
          })
      })
      .catch(function (error) {
        if (error.response) {
          swal({
            title: `${t(error.response.data.message)}`,
            icon: 'error',
          })
        }
      })
      .finally(() => {
        setBtnLoading(false)
      })
  }

  const textcondition = (type: any, data: any) => {
    let result = ''
    if (type == 'findoc') {
      switch (data) {
        case 'skbdn':
          result = 'SKBDN'
          break
        case 'bg':
          result = 'Bank Guarantee'
          break
        case 'lc':
          result = 'Letter of Credit'
          break
        default:
          break
      }
    } else if (type == 'skbdn') {
      switch (data) {
        case '1':
          result = 'At Sight'
          break
        case '2':
          result = 'Usance'
          break
        default:
          break
      }
    }
    return result
  }

  const condTOP = (top: any) => {
    let trimmedTOP = ''
    if (top?.slice(1, 100) != undefined)
      trimmedTOP = 'Within ' + top?.slice(1, 100) + t(' days Due net')
    if (top == 'Z0LC') return 'Letter of Credit TOP'
    else if (top == 'Z000') return 'Payable immediately Due net'
    else if (top != 'Z0LC' && top != 'Z000') return trimmedTOP
  }

  const [files, setFiles] = useState({file: null})

  const {t} = useTranslation()

  //#region
  const [produsen, setProdusen] = useState('')
  const [produsencode, setProdusenCode] = useState('')
  const [jenisFindoc, setJenisFindoc] = useState('')
  const [namaJenisFindoc, setNamaJenisFindoc] = useState('')
  const [skbn, setSKBN] = useState('')
  const [noFindoc, setNoFindoc] = useState('')
  const [extnoFindoc, setExtNoFindoc] = useState('')
  const [tanggalFindoc, setTanggalFindoc] = useState<any>()
  const [tanggalFindoc2, setTanggalFindoc2] = useState<any>()
  const [tanggalFindoc3, setTanggalFindoc3] = useState<any>()
  const [finDate, setFinDate] = useState<any>()
  const [namaFindoc, setNamaFindoc] = useState('')
  const [bank, setBank] = useState('')
  const [negara, setNegara] = useState('')
  const [negaraDesc, setNegaraDesc] = useState('')
  const [nilai, setNilai] = useState<any>()
  const [currency, setCurrency] = useState('')
  const [dari, setFrom] = useState<any>('')
  const [berlaku, setBerlaku] = useState<any>('')
  const [tglFindoc, setTglFindoc] = useState<any>('')
  const [dari2, setFrom2] = useState<any>()
  const [berlaku2, setBerlaku2] = useState<any>()
  const [incoterm2, setIncoterm2] = useState('')
  const [incoterm, setIncoterm] = useState('')
  const [uang, setUang] = useState<any>(0)
  const [hardcopy, setHardCopy] = useState(false)
  const [batas, setBatas] = useState('')
  const [batas2, setBatas2] = useState<any>('')
  const [TOP, setTOP] = useState('')
  const [file, setFile] = useState('')
  const [revisionNote, setRevisionNote] = useState('')
  const [rejectNote, setRejectNote] = useState('')
  const [status, setStatus] = useState(0)
  const [fullIncoterm, setFullIncoterm] = useState([])
  const [fullTOP, setFullTOP] = useState([])
  const [custCode, setCustCode] = useState('')
  const [getID, setID] = useState(0)
  const [residual, setResidual] = useState(0)
  const [used, setUsed] = useState(0)
  const [SAP, setSAP] = useState(0)
  const [keterangan, setKeterangan] = useState('')
  const [ship, setShip] = useState(false)
  const [customer, setCustomer] = useState('')
  const [titleCustomer, setTitleCustomer] = useState('')
  const [customerID, setCustomerID] = useState('')
  const [fullCustomer, setFullCustomer] = useState<any[]>([])
  const [showCustomer, setShowCustomer] = useState(false)
  const [showBank, setShowBank] = useState(false)
  const [fullBankKey, setFullBankKey] = useState<any[]>([])
  const [bankKey, setBankKey] = useState('')
  const [findocDesc, setFindocDesc] = useState('')
  const [shipCust, setShipCust] = useState('')
  const [approveState, setApproveState] = useState(false)
  const [showCommentCust, setShowCommentCust] = useState(false)
  const [commentCust, setCommentCust] = useState<any>([])
  const [tempComment, setTempComment] = useState('')
  const [skpp, setSkpp] = useState('')
  const [sektor, setSektor] = useState('')
  const [sektordesc, setSektordesc] = useState('')
  const [customerName, setCustomerName] = useState('')
  const [customerCode, setCustomerCode] = useState('')
  const [customerAddress, setCustomerAddress] = useState('')
  const [phoneNumber, setPhoneNumber] = useState('')
  const [emailCust, setEmailCust] = useState('')
  const [PICCust, setPICCust] = useState('')
  const [fromDate, setFromDate] = useState<any>()
  const [end2, setEnd2] = useState<any>()
  const [batasTanggal, setBatasTanggal] = useState<any>()
  const [sectorId, setSectorId] = useState<any>()
  const [tempRole, setTempRole] = useState<any[]>([])
  //#endregion

  const getData = async () => {
    setLoading(true)
    await getDetail(sessionStorage.getItem('id')).then((res) => {
      setSkpp(res.data.data.no_skpp == 'null' ? '' : res.data.data.no_skpp)
      setProdusen(res.data.data.sales_organization?.name)
      setProdusenCode(res.data.data.sales_org_code)
      setJenisFindoc(res.data.data.findoc_type)
      setNamaJenisFindoc(res.data.data.findoc_type_detail?.name)
      setSKBN(res.data.data.type_skbdn)
      setNoFindoc(res.data.data.findoc_number)
      setExtNoFindoc(res.data.data.num_findoc)
      setTanggalFindoc(res.data.data?.tgl_findoc)
      // console.log(new Date(res.data.data?.tgl_findoc))
      setTanggalFindoc2(new Date(res.data.data?.tgl_findoc))
      setTanggalFindoc3(res.data.data?.date_findoc)
      setFinDate(res.data.data?.date_findoc)
      setNamaFindoc(res.data.data.findoc_name)
      setBank(res.data.data.bank_name)
      setBankKey(res.data.data.bank_key)
      setNegara(res.data.data.negara)
      setNegaraDesc(res.data.data.negara_desc)
      setNilai(res.data.data?.nilai)
      // console.log(res.data.data.status)
      setStatus(res.data.data.status)
      setCurrency(res.data.data.currency ? res.data.data.currency : 'USD')
      setFrom(res.data.data.validity_date_from)
      setBerlaku(res.data.data.validity_date_to)
      setFrom2(res.data.data.valid_from_date)
      setFromDate(new Date(res.data.data?.validity_date_from))
      setBerlaku2(res.data.data.valid_to_date)
      setEnd2(new Date(res.data.data?.validity_date_to))
      setUang(res.data.data.allowance)
      setHardCopy(res.data.data.send_hard_copy)
      setID(res.data.data.id)
      setIncoterm(res.data.data.incoterm?.id)
      setIncoterm2(res.data.data.incoterm2_id)
      setBatas(res.data.data.delivery_deadline)
      setBatasTanggal(new Date(res.data.data.delivery_deadline + ' 00:00:00'))
      setBatas2(res.data.data.latest_shipment_date)
      setTOP(res.data.data.top)
      setFile(res.data.data.file_path + `&token=${localStorage.getItem('token')}`)
      setFileName(res.data.data.file)
      setResidual(res.data.data.resedual_value)
      setUsed(res.data.data.value_used)
      setSAP(res.data.data.sap_number)
      setKeterangan(res.data.data.description == 'null' ? '' : res.data.data.description)
      setShip(res.data.data.ship_to)
      setCustomer(
        res.data.data.customer_ship?.name == null ? '' : res.data.data.customer_ship?.name
      )
      setCustomerID(res.data.data.customer_ship_to == null ? '' : res.data.data.customer_ship_to)
      setFindocDesc(res.data.data.findoc_desc || `DF - ${res.data.data.findoc_number}`)
      setShipCust(
        res.data.data.customer_ship?.title == null
          ? res.data.data.customer_ship?.name
          : res.data.data.customer_ship_to +
              ' - ' +
              res.data.data.customer_ship?.title +
              ' ' +
              res.data.data.customer_ship?.name
      )

      setApproveState(setAsApproval(res.data.data))
      setSektor(res.data.data.sector_id)
      setSektordesc(res.data.data.sector?.name)
      setPICCust(res.data.data.customer?.name4)
      setEmailCust(res.data.data.customer?.user?.email)
      setPhoneNumber(res.data.data.customer?.user?.mobile_number)
      setCustomerAddress(res.data.data.customer?.address)
      setCustomerCode(res.data.data.customer?.customer_code)
      setCustomerName(res.data.data.customer?.name)
      setReceiptDate(res.data.data.receipt_date)
      setLastDateBol(res.data.data.last_date_bol)
      setPresentationDate(res.data.data.presentation_date)
      setOpeningDate(res.data.data.opening_date)
      setSectorId(res.data.data.sector_id)
    })
    await getIncoterm().then((res) => {
      setFullIncoterm(res.data.data)
    })
    await getTOPAnper().then((res) => {
      setFullTOP(res.data.data)
    })
    await getBankKey('', '', negara).then((res) => {
      setFullBankKey(res.data.data.data)
      setNumberURL2(res.data.data.links)
    })
    setLoading(false)
  }

  const setAsApproval = (findoc: any) => {
    const isLocOrSkbdn = ['skbdn', 'lc'].includes(findoc?.findoc_type)
    const role: any = localStorage.getItem('role-flag')
    const isFinance = role == 'finance'

    console.log(isLocOrSkbdn, role, hakAkses?.approve, findoc?.status)
    console.log(!isLocOrSkbdn && !isFinance && hakAkses?.approve)

    if ([1,3].includes(findoc?.status)) {
      if (isLocOrSkbdn && !isFinance && hakAkses?.approve) return true
      if (!isLocOrSkbdn && isFinance && hakAkses?.approve) return true
    } else if (findoc?.status == 4 && isFinance) return true

    return false
  }

  function formatDate(inputDate: string) {
    var parts = inputDate.split('-')
    var day = parts[0]
    var month = parts[1]
    var year = parts[2]

    var formattedDate = year + '-' + month + '-' + day
    return formattedDate
  }

  const getAllComment = async () => {
    await getComment(getID).then((res) => {
      setFullcomment(res.data.data)
    })
  }

  CustomUseEffect(() => {
    if (getID != 0) {
      getAllComment()
    }
  }, [showCommentCust])

  const handlePostComment = async () => {
    await postComment(language, {
      findoc_id: getID,
      user_id: localStorage.getItem('user-id'),
      comment: tempComment,
      credentials: localStorage.getItem('credential'),
    })
      .then((res) => {
        swal({
          title: `${t('Komentar Berhasil Ditambahkan')}`,
          icon: 'success',
        }).then(() => {
          getAllComment()
          setTempComment('')
          const areacomment = document.getElementById('areacomment') as HTMLInputElement
          if (areacomment != null) areacomment.value = ''
        })
      })
      .catch((error) => {
        swal({
          title: t(error.response.data.message),
          icon: 'error',
        })
      })
  }

  const handleCommentClick = (value: any) => {
    const areacomment = document.getElementById('areacomment') as HTMLInputElement
    if (areacomment != null) areacomment.defaultValue = value
  }

  CustomUseEffect(() => {
    const getListBankKey = async () => {
      await getBankKey('', '', negara).then((res) => {
        setFullBankKey(res.data.data.data)
        setNumberURL2(res.data.data.links)
      })
    }
    getListBankKey()
  }, [negara])

  const separator = (value: any, state1: any, state2: any) => {
    const temp = value.split(',')
    state1(temp[0])
    state2(temp[1])
  }

  // console.log(nilai)

  // console.log(roleUser)

  const [deposit, setDeposit] = useState('')

  // CustomUseEffect(() => {
  //   const countDeposit = () => {
  //     const temp = nilai + (nilai * (uang / 100))
  //     if (temp != null || !Number.isNaN(temp))
  //       return temp.toLocaleString()
  //     else
  //       return 0
  //   }
  //   setDeposit(String(countDeposit()))
  // }, [nilai, uang])

  const handleCustomer = async () => {
    await getCustomer(produsencode, '', '', '').then((res: any) => {
      setFullCustomer(res.data.data.data)
      setNumberURL(res.data.data.links)
      setShowCustomer(true)
    })
  }

  const [numberURL, setNumberURL] = useState([])
  const [numberURL2, setNumberURL2] = useState([])

  const paginateNumber = async (number: any) => {
    const customer_code = filterCustomer?.customer_code ?? ''
    const name = filterCustomer?.name ?? ''
    const res = await axios.get(
      `${number}&sales_org_code=&customer_code=${customer_code}&name=${name}`,
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('token')}`,
          apikey: `1k1BGGqAkfpXvHrxPCsWIUUDySfgVFYw`,
          Accept: 'application/json',
          'Access-Control-Allow-Origin': '*',
        },
      }
    )
    setFullCustomer(res.data.data.data)
    setNumberURL(res.data.data.links)
  }

  const paginateNumber2 = async (number: any) => {
    const bank_name = filterBankKey?.bank_name ?? ''
    const bank_branch = filterBankKey?.bank_branch ?? ''
    const res = await axios.get(
      `${number}&bank_name=${bank_name}&bank_branch=${bank_branch}&country=${negara}`,
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('token')}`,
          apikey: `1k1BGGqAkfpXvHrxPCsWIUUDySfgVFYw`,
          Accept: 'application/json',
          'Access-Control-Allow-Origin': '*',
        },
      }
    )
    setFullBankKey(res.data.data.data)
    setNumberURL2(res.data.data.links)
  }

  const [searchName, setSearchName] = useState('')
  const [searchRegion, setSearchRegion] = useState('')

  useEffect(() => {
    const getData = setTimeout(async () => {
      const customer_code = filterCustomer?.customer_code ?? ''
      const name = filterCustomer?.name ?? ''
      await getCustomer(produsencode, '', customer_code, name).then((res: any) => {
        setFullCustomer(res.data.data.data)
        setNumberURL(res.data.data.links)
      })
    }, 1000)

    return () => clearTimeout(getData)
  }, [filterCustomer?.customer_code, filterCustomer?.name, produsencode])

  useEffect(() => {
    const bank_name = filterBankKey?.bank_name ?? ''
    const bank_branch = filterBankKey?.bank_branch ?? ''
    const getData = setTimeout(async () => {
      await getBankKey(bank_name, bank_branch, negara).then((res: any) => {
        setFullBankKey(res.data.data.data)
        setNumberURL2(res.data.data.links)
      })
    }, 1000)

    return () => clearTimeout(getData)
  }, [searchName, searchRegion, filterBankKey, negara])

  const [language, setLanguage] = useState<any>()
  useEffect(() => {
    const interval = setInterval(() => {
      const getCookie = (name: string) => {
        const value = `; ${document.cookie}`
        const parts = value.split(`; ${name}=`)
        if (parts.length === 2) return parts.pop()?.split('~#~').shift()
      }
      let language = getCookie('i18next')
      setLanguage(language)
    }, 1000)
    return () => clearInterval(interval)
  }, [])

  function convertDatePicker(date: any) {
    let dd = String(date.getDate()).padStart(2, '0')
    let mm = String(date.getMonth() + 1).padStart(2, '0')
    let yyyy = String(date.getFullYear())
    return yyyy + '-' + mm + '-' + dd
  }

  function handleShowRoleName(role: any) {
    let temp = ''
    role.forEach((element: any, index: any) => {
      if (index + 1 == role.length) temp = temp + element
      else temp = temp + element + ', '
    })
    return temp
  }

  const handleSyncSAP = async () => {
    try {
      setLoadingBtnSync(true)
      const res = await syncFromSAP({
        lang: i18next.language,
        sap_number: SAP,
        credentials: localStorage.getItem('credential'),
      });
      swal({
        title: `${t(res.data.message)}`,
        icon: 'success',
      }).then(() => getData())
    } catch (err: any) {
      swal({
        title: `${t(err?.response?.data?.message)}`,
        icon: 'error',
      })
    } finally {
      setLoadingBtnSync(false)
    }
  }

  return (
    <>
      <PageTitle breadcrumbs={[]}>
        {intl.formatMessage({id: `• ${t('aside-findoc')} • Detail`})}
      </PageTitle>
      {roleUser == 'null' ? (
        <div className='card'>
          {loading ? (
            <div className='d-flex justify-content-center py-10'>
              <div className='lds-ellipsis'>
                <div></div>
                <div></div>
                <div></div>
                <div></div>
              </div>
            </div>
          ) : (
            <div className='card-body mt-5'>
              {status == 2 ? (
                <>
                  <Row>
                    <Col md={6}>
                      <div className='d-flex justify-content-between align-items-center mb-4'>
                        <Form.Label className='me-2'>{t('Customer Name')}</Form.Label>
                        <Form.Control
                          aria-label='Default example'
                          style={{width: '70%'}}
                          value={customerName}
                          disabled
                        />
                      </div>
                      <div className='d-flex justify-content-between align-items-center mb-4'>
                        <Form.Label className='me-2'>{t('Customer Number')}</Form.Label>
                        <Form.Control
                          aria-label='Default example'
                          style={{width: '70%'}}
                          value={customerCode}
                          disabled
                        />
                      </div>
                      <div className='d-flex justify-content-between align-items-center mb-4'>
                        <Form.Label className='me-2'>{t('Address')}</Form.Label>
                        <Form.Control
                          aria-label='Default example'
                          as='textarea'
                          style={{width: '70%', minHeight: '40px', height: 'auto'}}
                          value={customerAddress}
                          disabled
                        />
                      </div>
                      <div className='d-flex justify-content-between align-items-center mb-4'>
                        <Form.Label className='me-2'>Sales Org</Form.Label>
                        <Form.Control
                          aria-label='Default example'
                          style={{width: '70%'}}
                          value={produsen}
                          disabled
                        />
                      </div>
                      <div className='d-flex justify-content-between align-items-center mb-4'>
                        <Form.Label className='me-2'>
                          {t('Findoc Type')}
                          <span className='text-danger'>*</span>
                        </Form.Label>
                        <Form.Select
                          aria-label='Default select example'
                          style={{width: '70%'}}
                          onChange={(e: any) => {
                            setJenisFindoc(e.target.value)
                            if (e.target.value == 'lc') setCurrency('USD')
                          }}
                        >
                          {findocTypes.map((item: any, index: number) => {
                            return (
                              <option key={item?.code ?? index} value={item.code} selected={jenisFindoc == item.code ? true : false}>
                                {item?.name}
                              </option>
                            )
                          })}
                        </Form.Select>
                      </div>
                      {jenisFindoc == 'skbdn' ? (
                        <div className='d-flex justify-content-between align-items-center mb-4'>
                          <Form.Label className='me-2'>
                            {t('Skbdn Type')}
                            <span className='text-danger'>*</span>
                          </Form.Label>
                          <Form.Select
                            aria-label='Default select example'
                            style={{width: '70%'}}
                            onChange={(e: any) => setSKBN(e.target.value)}
                          >
                            <option selected hidden>
                              {textcondition('skbdn', skbn)}
                            </option>
                            <option value='1'>At Sight</option>
                            <option value='2'>Usance</option>
                          </Form.Select>
                        </div>
                      ) : (
                        ''
                      )}

                      <div className='d-flex justify-content-between align-items-center mb-4'>
                        <Form.Label className='me-2'>
                          {t('Ext Findoc Number')}
                          <span className='text-danger'>*</span>
                        </Form.Label>
                        <Form.Control
                          type='text'
                          placeholder={t('Ext Findoc Number')}
                          style={{width: '70%'}}
                          onChange={(e: any) => setExtNoFindoc(e.target.value)}
                          defaultValue={extnoFindoc}
                        />
                      </div>
                      <div className='d-flex justify-content-between align-items-center mb-4 w-100'>
                        <Form.Label className='' style={{maxWidth: '30%'}}>
                          {t('no skkp/lecto')}
                        </Form.Label>
                        <Form.Control
                          type='text'
                          defaultValue={skpp}
                          style={{width: '70%'}}
                          onChange={(e: any) => setSkpp(e.target.value)}
                        />
                      </div>

                      <div className='d-flex justify-content-between align-items-center mb-4'>
                        <Form.Label className='me-2'>{t('order-lampiran')}</Form.Label>
                        <Button
                          variant='primary'
                          onClick={() => {
                            setShowUpload(true)
                            ambilAttachment(idItem)
                          }}
                        >
                          {t('order-lampiran')}
                        </Button>
                      </div>
                      {/* {SAP == null || SAP == 0 ? (
                      <></>
                    ) : (
                      <div className='d-flex justify-content-between align-items-center mb-4'>
                        <Form.Label className='me-2'>{t("SAP Number")}</Form.Label>
                        <Form.Control
                          type='text'
                          placeholder={t("Enter SAP Number")}
                          style={{ width: "70%" }}
                          value={SAP}
                          disabled
                        />
                      </div>
                    )} */}
                      {/* <div className='d-flex justify-content-between align-items-center mb-4'>
                      <Form.Label className='me-2'>{t('Findoc Name')}<span className='text-danger'>*</span></Form.Label>
                      <Form.Control
                        type='text'
                        placeholder={t("Masukkan Nama Findoc")}
                        style={{ width: "70%" }}
                        onChange={(e: any) => setNamaFindoc(e.target.value)}
                        defaultValue={namaFindoc}
                      />
                    </div> */}

                      {/* <div className='d-flex justify-content-between align-items-center mb-4'>
                      <Form.Label className='me-2'>{t('sub-order-negara')}</Form.Label>
                      <Form.Select
                        placeholder={t("Enter Country")}
                        style={{ width: "70%" }}
                        onChange={(e: any) => separator(e.target.value, setNegara, setNegaraDesc)}
                      >
                        {Country.dataCountry.map((item: any) => {
                          return (
                            <>
                              {negaraDesc == item.name ? (
                                <option selected value={item.code + "," + item.name}>{item.name}</option>
                              ) : (
                                <option value={item.code + "," + item.name}>{item.name}</option>
                              )}

                            </>
                          )
                        })}
                      </Form.Select>
                    </div> */}
                      {/* <div className='d-flex justify-content-between align-items-center mb-4'>
                      <Form.Label className='me-2'>Bank<span className='text-danger'>*</span></Form.Label>
                      <div className="d-flex" style={{ width: "70%" }}>
                        <Form.Control type='text' size='sm' className='me-1 w-100' disabled placeholder='Bank' value={bank} style={{ width: "70%" }} />
                        <Button className="btn btn-primary d-flex justify-content-center align-items-center"
                          data-bs-toggle='tooltip'
                          data-bs-placement='top'
                          data-bs-trigger='hover'
                          title='Browse'
                          onClick={() => setShowBank(true)}>
                          <KTSVG path='/media/icons/duotune/browse.svg' className='svg-icon-3 ms-2' />
                        </Button>
                      </div>
                    </div> */}
                      {/* <div className='d-flex justify-content-between align-items-center mb-4'>
                      <Form.Label className='me-2'>{t('nilai')}<span className='text-danger'>*</span></Form.Label>
                      <Form.Control
                        placeholder={i18next.language === 'en' ? nilai?.toLocaleString('en', { maximumFractionDigits: 4 }) : nilai?.toLocaleString('id', { maximumFractionDigits: 4 })}
                        style={{ width: "70%" }}
                        onChange={(e: any) => setNilai(parseInt(e.target.value))}
                      />
                    </div> */}

                      {/* <div className='d-flex justify-content-between align-items-center mb-4'>
                      <Form.Label className='me-2'>TOP</Form.Label>
                      <Form.Select aria-label='Default select example' style={{ width: "70%" }} size='sm' onChange={e => setTOP(e.target.value)}>
                        <option selected hidden value={TOP}>{condTOP(TOP)}</option>
                        {fullTOP.map((item: any) => {
                          return <>
                            {item.code != "Z0LC" ? (
                              <option value={item.code}>{item.code?.slice(1, 100)} {t("Days")}</option>
                            ) : (
                              <option value={item.code}>Letter of Credit TOP</option>
                            )}
                          </>
                        })}
                      </Form.Select>
                    </div> */}
                    </Col>

                    <Col md={6}>
                      <div className='d-flex justify-content-between align-items-center mb-4'>
                        <Form.Label className='me-2'>{t('Phone Number')}</Form.Label>
                        <Form.Control
                          aria-label='Default example'
                          style={{width: '70%'}}
                          value={phoneNumber}
                          disabled
                        />
                      </div>
                      <div className='d-flex justify-content-between align-items-center mb-4'>
                        <Form.Label className='me-2'>{t('Email')}</Form.Label>
                        <Form.Control
                          aria-label='Default example'
                          style={{width: '70%'}}
                          value={emailCust}
                          disabled
                        />
                      </div>
                      <div className='d-flex justify-content-between align-items-center mb-4'>
                        <Form.Label className='me-2'>{t('PIC Customer')}</Form.Label>
                        <Form.Control
                          aria-label='Default example'
                          style={{width: '70%'}}
                          value={PICCust}
                          disabled
                        />
                      </div>
                      <div className='d-flex justify-content-between align-items-center mb-4'>
                        <Form.Label className='me-2'>
                          {t('sub-order-sektor')}
                          <span className='text-danger'>*</span>
                        </Form.Label>
                        <Form.Select
                          aria-label='Default select example'
                          id='sektor'
                          style={{width: '70%'}}
                          onChange={(e: any) => setSektor(e.target.value)}
                        >
                          <option hidden value=''>
                            {t('Pilih-sector')}{' '}
                          </option>
                          <option selected={sektor == '1' ? true : false} value='1'>
                            {t('Domestic Corporate')}{' '}
                          </option>
                          <option selected={sektor == '2' ? true : false} value='2'>
                            {t('Domestik Retail')}{' '}
                          </option>
                          <option selected={sektor == '3' ? true : false} value='3'>
                            {t('Export')}{' '}
                          </option>
                        </Form.Select>
                      </div>
                      <div className='d-flex justify-content-between align-items-center mb-4'>
                        <Form.Label className='me-2'>
                          {t('Tanggal Findoc')}
                          <span className='text-danger'>*</span>
                        </Form.Label>
                        <div style={{width: '70%'}}>
                          <input
                            type='date'
                            className='form-control'
                            style={{width: '70%'}}
                            defaultValue={tanggalFindoc2}
                            onChange={(date: any) => {
                              setTanggalFindoc2(date.target.value)
                              setTanggalFindoc(date.target.value)
                            }}
                          />
                        </div>
                        {/* <Form.Control
                          type='Date'
                          style={{width: '70%'}}
                          placeholder={tanggalFindoc?.slice(0, 10)}
                          onChange={(e: any) => setTanggalFindoc(e.target.value)}
                        /> */}
                      </div>
                      <div className='d-flex justify-content-between align-items-center mb-4'>
                        <Form.Label className='me-2'>
                          {t('Findoc Desc')}
                          <span className='text-danger'>*</span>
                        </Form.Label>
                        <Form.Control
                          type='text'
                          placeholder={t('Enter Findoc Desc')}
                          defaultValue={findocDesc}
                          style={{width: '70%'}}
                          onChange={(e: any) => setFindocDesc(e.target.value)}
                        />
                      </div>

                      {/* <div className='d-flex justify-content-between align-items-center mb-4'>
                      <Form.Label className='me-2'>{t('mataUang')}<span className='text-danger'>*</span></Form.Label>
                      {jenisFindoc == 'lc' ? (
                        <Form.Select
                          aria-label='Default select example'
                          style={{ width: "70%" }}
                          onChange={(e: any) => setCurrency(e.target.value)}
                          disabled
                        >
                          <option selected value='USD'>USD</option>
                        </Form.Select>
                      ) : (
                        <Form.Select
                          aria-label='Default select example'
                          style={{ width: "70%" }}
                          onChange={(e: any) => setCurrency(e.target.value)}
                        >
                          <option selected hidden>{currency}</option>
                          <option value='IDR'>IDR</option>
                          <option value='USD'>USD</option>
                        </Form.Select>
                      )}
                    </div> */}
                      {/* <div className='d-flex justify-content-between align-items-center mb-4'>
                      <Form.Label className='me-2'>{t("From")}</Form.Label>
                      <Form.Control type='Date' style={{ width: "70%" }} placeholder={dari?.slice(0, 10)} onChange={(e: any) => setFrom(e.target.value)} />
                    </div> */}
                      {/* <div className='d-flex justify-content-between align-items-center mb-4'>
                      <Form.Label className='me-2'>{t('masaBerlaku')}</Form.Label>
                      <Form.Control type='Date' style={{ width: "70%" }} placeholder={berlaku?.slice(0, 10)} onChange={(e: any) => setBerlaku(e.target.value)} />
                    </div> */}
                      {/* <div className='d-flex justify-content-between align-items-center mb-4'>
                      <Form.Label className='me-2'>Incoterm</Form.Label>
                      <Form.Select
                        aria-label='Default select example'
                        style={{ width: "70%" }}
                        onChange={(e: any) => setIncoterm(e.target.value)}
                      >
                        {fullIncoterm.map((item: any) => {
                          return (
                            <>
                              {item.id == incoterm ? (
                                <option selected value={item.id}>{item.code}</option>
                              ) : (
                                <option value={item.id}>{item.code}</option>
                              )}
                            </>
                          )
                        })}
                      </Form.Select>
                    </div> */}
                      {/* <div className='d-flex justify-content-between align-items-center mb-4'>
                      <Form.Label className='me-2'>Incoterm 2</Form.Label>
                      <Form.Control
                        placeholder="Incoterm 2"
                        style={{ width: "70%" }}
                        defaultValue={incotermincoterm}
                        onChange={(e: any) => setIncotermincoterm(e.target.value)}
                      />
                    </div> */}
                      {/* <div className='d-flex justify-content-between align-items-center mb-4'>
                      <Form.Label className='me-2'>{t('uangSaku')}<span className='text-danger'>*</span></Form.Label>
                      <Form.Control
                        placeholder={i18next.language === 'en' ? uang?.toLocaleString('en', { maximumFractionDigits: 4 }) : uang?.toLocaleString('id', { maximumFractionDigits: 4 })}
                        style={{ width: "70%" }}
                        onChange={(e: any) => setUang(parseInt(e.target.value))}
                      />
                    </div> */}
                      {/* <div className='d-flex justify-content-between align-items-center mb-4'>
                  <Form.Label className='me-2'>{t("Deposit")}</Form.Label>
                  <Form.Control style={{ width: "70%" }} disabled value={deposit} />
                </div> */}
                      {/* <div className='d-flex justify-content-between align-items-center mt-5 mb-5'>
                      <Form.Label className='me-2'>{t('pengirimanHardCopy')}</Form.Label>
                      <input name='hardCopy' className='mt-5 mb-2' type='checkbox' id='ckbox-hardcopy' defaultChecked={hardcopy} />
                    </div> */}
                      {/* <div className='d-flex justify-content-between align-items-center mb-4'>
                      <Form.Label className='me-2'>{t('batasAkhir')}</Form.Label>
                      <Form.Control
                        type='Date'
                        style={{ width: "70%" }}
                        placeholder={batas.slice(0, 10)}
                        onChange={(e: any) => setBatas(e.target.value)}
                      />
                    </div> */}

                      {/* <div className='d-flex justify-content-between align-items-center mb-4'>
                      <Form.Label className='me-2'>{t("Ship To")}</Form.Label>
                      <Form.Check reverse name='hardCopy' className='mt-5 mb-2' defaultChecked={ship} type='checkbox' id='ckbox-ship' />
                    </div> */}

                      <div className='d-flex justify-content-between align-items-center mb-4'>
                        <Form.Label className='me-2'>{t('Keterangan')}</Form.Label>
                        <Form.Control
                          as='textarea'
                          defaultValue={keterangan}
                          style={{width: '70%', height: '40px'}}
                          onChange={(e: any) => setKeterangan(e.target.value)}
                        />
                      </div>
                    </Col>
                  </Row>
                  <div className='my-3'>
                    <div className='d-flex'>
                      <Form.Label>
                        File Findoc
                        <span className='text-danger'>*</span>
                      </Form.Label>
                    </div>
                    <div className='d-flex'>
                      <div className='w-100'>
                        <InputFile
                            setFileName={setNamaFile}
                            setFiles={setFiles}
                            isBase64={false}
                        />
                      </div>
                      <div
                        className='d-flex justify-content-end align-items-center'
                        style={{minWidth: '150px'}}
                      >
                        {fileName ? (
                          <a href={file} download className='btn btn-primary align-items-center' target='blank'> 
                            {t('Download')}
                          </a>
                        ) : (
                            <button className='btn btn-primary align-items-center' disabled>
                              {t('Download')}
                            </button>
                        )}
                        {/* <Button className='primary' onClick={() => window.open(file)}>
                          {t('Download')}
                        </Button> */}
                      </div>
                    </div>
                  </div>
                </>
              ) : status == 5 ? (
                <Row>
                  <Col md={6}>
                    <div className='d-flex justify-content-between align-items-center mb-4'>
                      <Form.Label className='me-2'>Sales Org</Form.Label>
                      <Form.Control
                        aria-label='Default example'
                        style={{width: '70%'}}
                        value={produsen}
                        disabled
                      />
                    </div>
                    <div className='d-flex justify-content-between align-items-center mb-4'>
                      <Form.Label className='me-2'>{t('Findoc Type')}</Form.Label>
                      <Form.Control
                        aria-label='Default example'
                        style={{width: '70%'}}
                        value={namaJenisFindoc}
                        disabled
                      />
                    </div>
                    {jenisFindoc == 'skbdn' ? (
                      <div className='d-flex justify-content-between align-items-center mb-4'>
                        <Form.Label className='me-2'>{t('Skbdn Type')}</Form.Label>
                        <Form.Control
                          aria-label='Default example'
                          style={{width: '70%'}}
                          value={textcondition('skbdn', skbn)}
                          disabled
                        />
                      </div>
                    ) : (
                      ''
                    )}

                    <div className='d-flex justify-content-between align-items-center mb-4'>
                      <Form.Label className='me-2'>{t('Findoc Number')}</Form.Label>
                      <Form.Control
                        type='text'
                        placeholder={t('Enter Findoc Num')}
                        style={{width: '70%'}}
                        value={noFindoc}
                        disabled
                      />
                    </div>
                    <div className='d-flex justify-content-between align-items-center mb-4'>
                      <Form.Label className='me-2'>{t('Ext Findoc Number')}</Form.Label>
                      <Form.Control
                        type='text'
                        // placeholder={t('Ext Findoc Number')}
                        style={{width: '70%'}}
                        value={extnoFindoc}
                        disabled
                      />
                    </div>
                    <div className='d-flex justify-content-between align-items-center mb-4 w-100'>
                      <Form.Label className='' style={{width: '30%'}}>
                        {t('no skkp/lecto')}
                      </Form.Label>
                      <Form.Control
                        type='text'
                        defaultValue={skpp == null || skpp == 'null' ? '' : skpp}
                        style={{width: '70%'}}
                        disabled
                      />
                    </div>
                    {SAP == null || SAP == 0 ? (
                      ''
                    ) : (
                      <div className='d-flex justify-content-between align-items-center mb-4'>
                        <Form.Label className='me-2'>{t('SAP Number')}</Form.Label>
                        <Form.Control
                          type='text'
                          // placeholder={t("Enter SAP Number")}
                          style={{width: '70%'}}
                          value={SAP}
                          disabled
                        />
                      </div>
                    )}
                    <div className='d-flex justify-content-between align-items-center mb-4'>
                      <Form.Label className='me-2'>{t('Tanggal Findoc')}</Form.Label>
                      <div style={{width: '70%'}}>
                        <Form.Control
                          type='text'
                          className='form-control'
                          value={dateformat(tanggalFindoc3)}
                          disabled
                        />
                      </div>
                    </div>

                    <div className='d-flex justify-content-between align-items-center mb-4'>
                      <Form.Label className='me-2'>{t('Findoc Desc')}</Form.Label>
                      <Form.Control
                        type='text'
                        // placeholder={t("Enter Findoc Desc")}
                        defaultValue={findocDesc}
                        style={{width: '70%'}}
                        disabled
                      />
                    </div>
                    <div className='d-flex justify-content-between align-items-center mb-4'>
                      <Form.Label className='me-2'>
                        {t('Bank Country')}
                        <span hidden={approveState ? false : true} className='text-danger'>
                          *
                        </span>
                      </Form.Label>
                      <Form.Select
                        placeholder={t('Bank Country')}
                        style={{width: '70%'}}
                        disabled={approveState ? false : true}
                        onChange={(e: any) => {
                          separator(e.target.value, setNegara, setNegaraDesc)
                          setBankKey('')
                          setBank('')
                        }}
                      >
                        {approveState ? (
                          <>
                            <option selected>
                              {t('pilih')} {t('Bank Country')}
                            </option>
                            {Country.dataCountry.map((item: any) => {
                              return (
                                <>
                                  {negaraDesc == item.name ? (
                                    <option selected value={item.code + ',' + item.name}>
                                      {item.name}
                                    </option>
                                  ) : (
                                    <option value={item.code + ',' + item.name}>{item.name}</option>
                                  )}
                                </>
                              )
                            })}
                          </>
                        ) : (
                          <option selected>{negaraDesc}</option>
                        )}
                      </Form.Select>
                    </div>
                    <div className='d-flex justify-content-between align-items-center mb-4'>
                      <Form.Label className='me-2'>Bank Key</Form.Label>
                      <div className='d-flex' style={{width: '70%'}}>
                        <Form.Control
                          type='text'
                          size='sm'
                          className='me-1 w-100'
                          disabled
                          placeholder={approveState ? 'Bank Key' : ''}
                          value={bank}
                        />
                      </div>
                    </div>

                    <div className='d-flex justify-content-between align-items-center mb-4'>
                      <Form.Label className='me-2'>{t('Finance doc. value')}</Form.Label>
                      {approveState ? (
                        <CurrencyInput
                          style={{width: '70%'}}
                          className='form-control form-control-sm'
                          placeholder={approveState ? t('Finance doc. value') : ''}
                          decimalSeparator={language === 'en' ? '.' : ','}
                          groupSeparator={language === 'en' ? ',' : '.'}
                          onValueChange={(e: any) => {
                            setNilai(e)
                          }}
                          decimalsLimit={2}
                        />
                      ) : (
                        <Form.Control
                          type='text'
                          style={{width: '70%'}}
                          disabled
                          value={
                            i18next.language === 'en'
                              ? nilai?.toLocaleString('en', {maximumFractionDigits: 4})
                              : nilai?.toLocaleString('id', {maximumFractionDigits: 4})
                          }
                        />
                      )}
                    </div>

                    <div className='d-flex justify-content-between align-items-center mb-4'>
                      <Form.Label className='me-2'>{t('Terms of Payment')}</Form.Label>
                      <Form.Select
                        aria-label='Default select example'
                        style={{width: '70%'}}
                        disabled={approveState ? false : true}
                        onChange={(e: any) => setTOP(e.target.value)}
                      >
                        <option>
                          {t('pilih')} {t('Terms of Payment')}
                        </option>
                        <option selected={approveState ? false : true} hidden></option>
                        {fullTOP.map((item: any) => {
                          return (
                            <>
                              {TOP == item.code ? (
                                <option selected value={item.code}>
                                  {item.top_desc}
                                </option>
                              ) : (
                                <option value={item.code}>{item.top_desc}</option>
                              )}
                            </>
                          )
                        })}
                      </Form.Select>
                    </div>

                    <div className='d-flex justify-content-between align-items-center mb-4'>
                      <Form.Label className='me-2'>File Findoc</Form.Label>
                      {fileName ? (
                          <a href={file} download className='btn btn-primary align-items-center' style={{width: '10rem'}} target='blank'> 
                            {t('Download')}
                          </a>
                        ) : (
                            <button className='btn btn-primary align-items-center' disabled>
                              {t('Download')}
                            </button>
                        )}
                      {/* <Button className='primary' onClick={() => window.open(file)}>
                          {t('Download')}
                        </Button> */}
                    </div>

                    <div className='d-flex justify-content-between align-items-center mb-4'>
                      <Form.Label className='me-2'>{t('order-lampiran')}</Form.Label>
                      <Button
                        style={{width: '10rem'}}
                        variant='primary'
                        onClick={() => {
                          setShowUpload(true)
                          ambilAttachment(idItem)
                        }}
                      >
                        {t('order-lampiran')}
                      </Button>
                    </div>
                  </Col>
                  <Col md={6}>
                    <div className='d-flex justify-content-between align-items-center mb-4'>
                      <Form.Label className='me-2'>{t('sub-order-sektor')}</Form.Label>
                      <Form.Control defaultValue={t(sektordesc)} style={{width: '70%'}} disabled />
                    </div>

                    <div className='d-flex justify-content-between align-items-center mb-4'>
                      <Form.Label className='me-2'>{t('mataUang')}</Form.Label>
                      {negara == 'ID' || negara == null ? (
                        <Form.Control type='text' disabled value='IDR' style={{width: '70%'}} />
                      ) : (
                        <Form.Control type='text' disabled value='USD' style={{width: '70%'}} />
                      )}
                    </div>
                    <div className='d-flex justify-content-between align-items-center mb-4'>
                      <Form.Label className='me-2'>
                        {t('Valid Start Date')}
                        <span hidden={approveState ? false : true} className='text-danger'>
                          *
                        </span>
                      </Form.Label>
                      {approveState ? (
                        <Form.Control
                          type='Date'
                          style={{width: '70%'}}
                          onChange={(e: any) => setFrom(e.target.value)}
                        />
                      ) : (
                        <Form.Control disabled style={{width: '70%'}} value={dateformat(dari)} />
                      )}
                    </div>
                    <div className='d-flex justify-content-between align-items-center mb-4'>
                      <Form.Label className='me-2'>
                        {t('valid End Date')}
                        <span hidden={approveState ? false : true} className='text-danger'>
                          *
                        </span>
                      </Form.Label>
                      {approveState ? (
                        <Form.Control
                          type='Date'
                          style={{width: '70%'}}
                          onChange={(e: any) => setBerlaku(e.target.value)}
                        />
                      ) : (
                        <Form.Control disabled style={{width: '70%'}} value={dateformat(berlaku)} />
                      )}
                    </div>
                    <div className='d-flex justify-content-between align-items-center mb-4'>
                      <Form.Label className='me-2'>
                        Incoterm
                        <span hidden={approveState ? false : true} className='text-danger'>
                          *
                        </span>
                      </Form.Label>
                      <Form.Select
                        aria-label='Default select example'
                        style={{width: '70%'}}
                        onChange={(e: any) => setIncoterm(e.target.value)}
                        disabled={approveState ? false : true}
                      >
                        <option>{t('pilih')} Incoterm</option>
                        <option selected={approveState ? false : true} hidden></option>
                        {fullIncoterm.map((item: any) => {
                          return (
                            <>
                              {item.id == incoterm ? (
                                <option selected value={item.id}>
                                  {item.code}
                                </option>
                              ) : (
                                <option value={item.id}>{item.code}</option>
                              )}
                            </>
                          )
                        })}
                      </Form.Select>
                    </div>
                    <div className='d-flex justify-content-between align-items-center mb-4'>
                      <Form.Label className='me-2'>Incoterm 2</Form.Label>
                      <Form.Control
                        style={{width: '70%'}}
                        defaultValue={incoterm2}
                        placeholder='Incoterm 2'
                        disabled={approveState ? false : true}
                        onChange={(e: any) => setIncoterm2(e.target.value)}
                      />
                    </div>
                    <div className='d-flex justify-content-between align-items-center mb-2'>
                      <Form.Label className='me-2'>{t('uangSaku')}</Form.Label>
                      {approveState ? (
                         <InputGroup style={{width: '70%'}}>
                            <CurrencyInput
                              className='form-control form-control-sm'
                              value={
                                i18next.language === 'en'
                                  ? uang?.toLocaleString('en', {maximumFractionDigits: 2})
                                  : uang?.toLocaleString('id', {maximumFractionDigits: 2})
                              }
                              disabled={approveState ? false : true}
                              placeholder={t('uangSaku')}
                              decimalSeparator={language === 'en' ? '.' : ','}
                              groupSeparator={language === 'en' ? ',' : '.'}
                              onValueChange={(value: any) => {
                                let _value = value?.replace(/,/g, '.')
                                if(_value > 100) _value = 100
                                setUang(_value)
                              }}
                              max={100}
                              decimalsLimit={2}
                            />
                            <InputGroup.Text id='basic-addon2'>%</InputGroup.Text>
                          </InputGroup>
                        // <InputGroup style={{width: '70%'}}>
                        //   <Form.Control
                        //     type='text'
                        //     placeholder={t('uangSaku')}
                        //     defaultValue={
                        //       i18next.language === 'en'
                        //         ? uang?.toLocaleString('en', {maximumFractionDigits: 4})
                        //         : uang?.toLocaleString('id', {maximumFractionDigits: 4})
                        //     }
                        //     disabled={approveState ? false : true}
                        //     onChange={(e: any) => setUang(e.target.value)}
                        //   />
                        //   <InputGroup.Text id='basic-addon2'>%</InputGroup.Text>
                        // </InputGroup>
                      ) : (
                        <InputGroup style={{width: '70%'}}>
                          <CurrencyInput
                            className='form-control form-control-sm'
                            value={
                              i18next.language === 'en'
                                ? uang?.toLocaleString('en', {maximumFractionDigits: 2})
                                : uang?.toLocaleString('id', {maximumFractionDigits: 2})
                            }
                            disabled={approveState ? false : true}
                            placeholder={t('uangSaku')}
                            decimalSeparator={language === 'en' ? '.' : ','}
                            groupSeparator={language === 'en' ? ',' : '.'}
                            onValueChange={(value: any) => {
                              let _value = value?.replace(/,/g, '.')
                              if(_value > 100) _value = 100
                              setUang(_value)
                            }}
                            max={100}
                            decimalsLimit={2}
                          />
                          <InputGroup.Text id='basic-addon2'>%</InputGroup.Text>
                        </InputGroup>
                        // <Form.Control
                        //   type='text'
                        //   style={{width: '70%'}}
                        //   defaultValue={
                        //     i18next.language === 'en'
                        //       ? uang?.toLocaleString('en', {maximumFractionDigits: 4}) + '%'
                        //       : uang?.toLocaleString('id', {maximumFractionDigits: 4}) + '%'
                        //   }
                        //   disabled={approveState ? false : true}
                        //   onChange={(e: any) => setUang(e.target.value)}
                        // />
                      )}
                    </div>

                    <div className='d-flex justify-content-between align-items-center mb-4 w-100'>
                      <Form.Label className='' style={{width: '30%'}}>
                        {t('Latest Shipment Date')}
                        <span hidden={approveState ? false : true} className='text-danger'>
                          *
                        </span>
                      </Form.Label>
                      {approveState ? (
                        <Form.Control
                          type='Date'
                          style={{width: '70%'}}
                          onChange={(e: any) => setBatas(e.target.value)}
                        />
                      ) : (
                        <Form.Control disabled style={{width: '70%'}} value={dateformat(batas)} />
                      )}
                    </div>

                    <div className='d-flex justify-content-between align-items-center mb-4'>
                      <Form.Label className='me-2'>{t('receipt_date')}</Form.Label>
                      <Form.Control
                        disabled
                        style={{width: '70%'}}
                        value={dateformat(receiptDate)}
                      />
                    </div>

                    <div className='d-flex justify-content-between align-items-center mb-4'>
                      <Form.Label className='me-2'>{t('last_date_bol')}</Form.Label>
                      <Form.Control
                        disabled
                        style={{width: '70%'}}
                        value={dateformat(lastDateBol)}
                      />
                    </div>

                    <div className='d-flex justify-content-between align-items-center mb-4'>
                      <Form.Label className='me-2'>{t('presentation_date')}</Form.Label>
                      <Form.Control
                        disabled
                        style={{width: '70%'}}
                        value={dateformat(presentationDate)}
                      />
                    </div>

                    <div className='d-flex justify-content-between align-items-center mb-4'>
                      <Form.Label className='me-2'>{t('opening_date')}</Form.Label>
                      <Form.Control
                        disabled
                        style={{width: '70%'}}
                        value={dateformat(openingDate)}
                      />
                    </div>

                    <div className='d-flex justify-content-between align-items-center mb-4'>
                      <Form.Label className='me-2'>{t('Ship-to Party')}</Form.Label>
                      <Form.Check
                        reverse
                        disabled={approveState ? false : true}
                        className='mt-5 mb-2'
                        type='checkbox'
                        id='ckbox-ship'
                        defaultChecked={ship}
                        onClick={() => setShip(!ship)}
                      />
                    </div>
                    {ship ? (
                      <div className='d-flex justify-content-between align-items-center mb-4'>
                        <Form.Label className='me-2'></Form.Label>
                        <div className='d-flex' style={{width: '70%'}}>
                          <Form.Control
                            type='text'
                            size='sm'
                            className='w-100'
                            disabled
                            value={shipCust}
                            style={{width: '70%'}}
                          />
                        </div>
                      </div>
                    ) : (
                      ''
                    )}

                    <div className='d-flex justify-content-between align-items-center mb-4'>
                      <Form.Label className='me-2'>{t('Keterangan')}</Form.Label>
                      <Form.Control
                        as='textarea'
                        defaultValue={keterangan == null || keterangan == 'null' ? '' : keterangan}
                        style={{width: '70%', height: '40px'}}
                        disabled
                      />
                    </div>
                  </Col>
                </Row>
              ) : (
                <Row>
                  <Col md={6}>
                    <div className='d-flex justify-content-between align-items-center mb-4'>
                      <Form.Label className='me-2'>{t('Customer Name')}</Form.Label>
                      <Form.Control
                        aria-label='Default example'
                        style={{width: '70%'}}
                        value={customerName}
                        disabled
                      />
                    </div>
                    <div className='d-flex justify-content-between align-items-center mb-4'>
                      <Form.Label className='me-2'>{t('Customer Number')}</Form.Label>
                      <Form.Control
                        aria-label='Default example'
                        style={{width: '70%'}}
                        value={customerCode}
                        disabled
                      />
                    </div>
                    <div className='d-flex justify-content-between align-items-center mb-4'>
                      <Form.Label className='me-2'>{t('Address')}</Form.Label>
                      <Form.Control
                        aria-label='Default example'
                        as='textarea'
                        style={{width: '70%', minHeight: '40px', height: 'auto'}}
                        value={customerAddress}
                        disabled
                      />
                    </div>
                    <div className='d-flex justify-content-between align-items-center mb-4'>
                      <Form.Label className='me-2'>Sales Org</Form.Label>
                      <Form.Control
                        aria-label='Default example'
                        style={{width: '70%'}}
                        value={produsen}
                        disabled
                      />
                    </div>
                    <div className='d-flex justify-content-between align-items-center mb-4'>
                      <Form.Label className='me-2'>{t('Findoc Type')}</Form.Label>
                      <Form.Control
                        aria-label='Default example'
                        style={{width: '70%'}}
                        value={namaJenisFindoc}
                        disabled
                      />
                    </div>
                    {jenisFindoc == 'skbdn' ? (
                      <div className='d-flex justify-content-between align-items-center mb-4'>
                        <Form.Label className='me-2'>{t('Skbdn Type')}</Form.Label>
                        <Form.Control
                          aria-label='Default example'
                          style={{width: '70%'}}
                          value={textcondition('skbdn', skbn)}
                          disabled
                        />
                      </div>
                    ) : (
                      ''
                    )}

                    <div className='d-flex justify-content-between align-items-center mb-4'>
                      <Form.Label className='me-2'>{t('Ext Findoc Number')}</Form.Label>
                      <Form.Control
                        type='text'
                        placeholder={t('Enter Findoc Num')}
                        style={{width: '70%'}}
                        value={extnoFindoc}
                        disabled
                      />
                    </div>
                    <div className='d-flex justify-content-between align-items-center mb-4'>
                      <Form.Label className=''>{t('no skkp/lecto')}</Form.Label>
                      <Form.Control style={{width: '70%'}} disabled value={skpp} />
                    </div>
                    <div className='d-flex justify-content-between align-items-center mb-4'>
                      <Form.Label className='me-2'>{t('order-lampiran')}</Form.Label>
                      <Button
                        variant='primary'
                        onClick={() => {
                          setShowUpload(true)
                          ambilAttachment(idItem)
                        }}
                      >
                        {t('order-lampiran')}
                      </Button>
                    </div>
                    {/* {SAP == null || SAP == 0 ? (
                    <></>
                  ) : (
                    <div className='d-flex justify-content-between align-items-center mb-4'>
                      <Form.Label className='me-2'>{t("SAP Number")}</Form.Label>
                      <Form.Control
                        type='text'
                        placeholder={t("Enter SAP Number")}
                        style={{ width: "70%" }}
                        value={SAP}
                        disabled
                      />
                    </div>
                  )} */}
                    {/* <div className='d-flex justify-content-between align-items-center mb-4'>
                    <Form.Label className='me-2'>{t('Findoc_Name')}<span className='text-danger'>*</span></Form.Label>
                    <Form.Control
                      type='text'
                      placeholder={t("Masukkan Nama Findoc")}
                      style={{ width: "70%" }}
                      disabled
                      value={namaFindoc}
                    />
                  </div> */}
                    {/* <div className='d-flex justify-content-between align-items-center mb-4'>
                    <Form.Label className='me-2'>{t('sub-order-negara')}</Form.Label>
                    <Form.Control
                      type='text'
                      placeholder={t("Enter Country")}
                      style={{ width: "70%" }}
                      disabled
                      value={negaraDesc}
                    />
                  </div> */}
                    {/* <div className='d-flex justify-content-between align-items-center mb-4'>
                    <Form.Label className='me-2'>Bank<span className='text-danger'>*</span></Form.Label>
                    <Form.Control
                      type='text'
                      placeholder={t("Bank")}
                      style={{ width: "70%" }}
                      disabled
                      value={bank}
                    />
                  </div> */}
                    {/* <div className='d-flex justify-content-between align-items-center mb-4'>
                    <Form.Label className='me-2'>{t('nilai')}<span className='text-danger'>*</span></Form.Label>
                    <Form.Control
                      placeholder={t("Enter Value")}
                      style={{ width: "70%" }}
                      disabled
                      value={i18next.language === 'en' ? nilai?.toLocaleString('en', { maximumFractionDigits: 4 }) : nilai?.toLocaleString('id', { maximumFractionDigits: 4 })}
                    />
                  </div> */}

                    {/* <div className='d-flex justify-content-between align-items-center mb-4'>
                    <Form.Label className='me-2'>TOP</Form.Label>
                    {TOP != "Z0LC" ? (
                      <Form.Control
                        aria-label='Default select example'
                        style={{ width: "70%" }}
                        disabled
                        value={TOP.slice(1, 100) + t(" Days")}
                      />
                    ) : (
                      <Form.Control
                        aria-label='Default select example'
                        style={{ width: "70%" }}
                        disabled
                        value="Letter of Credit TOP"
                      />
                    )}
                  </div> */}
                  </Col>

                  <Col md={6}>
                    <div className='d-flex justify-content-between align-items-center mb-4'>
                      <Form.Label className='me-2'>{t('Phone Number')}</Form.Label>
                      <Form.Control
                        aria-label='Default example'
                        style={{width: '70%'}}
                        value={phoneNumber}
                        disabled
                      />
                    </div>
                    <div className='d-flex justify-content-between align-items-center mb-4'>
                      <Form.Label className='me-2'>{t('Email')}</Form.Label>
                      <Form.Control
                        aria-label='Default example'
                        style={{width: '70%'}}
                        value={emailCust}
                        disabled
                      />
                    </div>
                    <div className='d-flex justify-content-between align-items-center mb-4'>
                      <Form.Label className='me-2'>{t('PIC Customer')}</Form.Label>
                      <Form.Control
                        aria-label='Default example'
                        style={{width: '70%'}}
                        value={PICCust}
                        disabled
                      />
                    </div>
                    <div className='d-flex justify-content-between align-items-center mb-4'>
                      <Form.Label className='me-2'>{t('sub-order-sektor')}</Form.Label>
                      <Form.Control disabled defaultValue={t(sektordesc)} style={{width: '70%'}} />
                    </div>
                    <div className='d-flex justify-content-between align-items-center mb-4'>
                      <Form.Label className='me-2'>{t('Tanggal Findoc')}</Form.Label>
                      <div style={{width: '70%'}}>
                        <Form.Control
                          disabled
                          className='form-control'
                          value={dateformat(tanggalFindoc3)}
                        />
                      </div>
                    </div>
                    <div className='d-flex justify-content-between align-items-center mb-4'>
                      <Form.Label className='me-2'>{t('Findoc Desc')}</Form.Label>
                      <Form.Control
                        type='text'
                        placeholder={t('Findoc Desc')}
                        defaultValue={findocDesc}
                        style={{width: '70%'}}
                        disabled
                      />
                    </div>

                    {/* <div className='d-flex justify-content-between align-items-center mb-4'>
                    <Form.Label className='me-2'>{t('mataUang')}<span className='text-danger'>*</span></Form.Label>
                    <Form.Control
                      aria-label='Default example'
                      style={{ width: "70%" }}
                      disabled
                      value={currency}
                    />
                  </div> */}
                    {/* <div className='d-flex justify-content-between align-items-center mb-4'>
                    <Form.Label className='me-2'>{t("From")}</Form.Label>
                    <Form.Control style={{ width: "70%" }} disabled value={dari?.slice(0, 10)} />
                  </div> */}
                    {/* <div className='d-flex justify-content-between align-items-center mb-4'>
                    <Form.Label className='me-2'>{t('masaBerlaku')}</Form.Label>
                    <Form.Control style={{ width: "70%" }} disabled value={berlaku?.slice(0, 10)} />
                  </div> */}
                    {/* <div className='d-flex justify-content-between align-items-center mb-4'>
                    <Form.Label className='me-2'>Incoterm</Form.Label>
                    <Form.Control
                      aria-label='Default example'
                      style={{ width: "70%" }}
                      disabled
                      value={incoterm2}
                    />
                  </div> */}
                    {/* <div className='d-flex justify-content-between align-items-center mb-4'>
                    <Form.Label className='me-2'>Incoterm 2</Form.Label>
                    <Form.Control
                      aria-label='Default example'
                      style={{ width: "70%" }}
                      disabled
                      value={incotermincoterm}
                    />
                  </div> */}
                    {/* <div className='d-flex justify-content-between align-items-center mb-4'>
                    <Form.Label className='me-2'>{t('uangSaku')}<span className='text-danger'>*</span></Form.Label>
                    <Form.Control
                      placeholder={t('Enter Allowance')}
                      style={{ width: "70%" }}
                      disabled
                      value={i18next.language === 'en' ? uang?.toLocaleString('en', { maximumFractionDigits: 4 }) : uang?.toLocaleString('id', { maximumFractionDigits: 4 })}
                    />
                  </div> */}
                    {/* <div className='d-flex justify-content-between align-items-center mb-4'>
                    <Form.Label className='me-2'>{t('resedual_value')}</Form.Label>
                    <Form.Control
                      placeholder={t('Enter Allowance')}
                      style={{ width: "70%" }}
                      disabled
                      value={residual?.toLocaleString()}
                    />
                  </div>
                  <div className='d-flex justify-content-between align-items-center mb-4'>
                    <Form.Label className='me-2'>{t('value_used')}</Form.Label>
                    <Form.Control
                      placeholder={t('Enter Allowance')}
                      style={{ width: "70%" }}
                      disabled
                      value={used?.toLocaleString()}
                    />
                  </div> */}
                    {/* {hardcopy ? (
                    <div className='d-flex justify-content-between align-items-center mt-8 mb-8'>
                      <Form.Label className='me-2'>{t('pengirimanHardCopy')}</Form.Label>
                      <Form.Check reverse name='hardCopy' type='checkbox' disabled checked={hardcopy} />
                    </div>
                  ) : ''} */}

                    {/* <div className='d-flex justify-content-between align-items-center mb-4'>
                    <Form.Label className='me-2'>{t('batasAkhir')}</Form.Label>
                    <Form.Control
                      aria-label='Default example'
                      style={{ width: "70%" }}
                      disabled
                      value={batas}
                    />
                  </div> */}

                    {/* {ship == true ? (
                    <div className='d-flex justify-content-between align-items-center mb-4'>
                      <Form.Label className='me-2'>{t("Ship To")}</Form.Label>
                      {status == 4 ? (
                        <Form.Control
                          style={{ width: "70%" }}
                          disabled
                          value={shipCust}
                        />
                      ) : (
                        <Form.Check reverse name='hardCopy' className='mt-5 mb-2' type='checkbox' defaultChecked={ship} id='ckbox-ship' />
                      )}
                    </div>
                  ) : ''} */}

                    <div className='d-flex justify-content-between align-items-center mb-4'>
                      <Form.Label className='me-2'>{t('Keterangan')}</Form.Label>
                      <Form.Control
                        as='textarea'
                        disabled
                        defaultValue={keterangan}
                        style={{width: '70%', height: '40px'}}
                      />
                    </div>

                    <div className='d-flex justify-content-between align-items-center mb-4'>
                      <Form.Label className='me-2'>File Findoc</Form.Label>
                      {fileName ? (
                          <a href={file} download className='btn btn-primary align-items-center' target='blank'> 
                            {t('Download')}
                          </a>
                        ) : (
                            <button className='btn btn-primary align-items-center' disabled>
                              {t('Download')}
                            </button>
                        )}
                      {/* <Button className='primary' onClick={() => window.open(file)}>
                        {t('Download')}
                      </Button> */}
                    </div>
                  </Col>
                </Row>
              )}

              <div className='d-flex justify-content-end mt-8'>
                <Link to={'/financial'}>
                  <button className='btn btn-secondary me-1'>{t('order-kembali')}</button>
                </Link>
                <Button className='btn btn-info me-1' onClick={() => setShowCommentCust(true)}>
                  {t('Chat')}
                </Button>
                {status == 2 ? (
                  <Button
                    className='btn btn-primary'
                    onClick={() => createFindoc()}
                    disabled={btnLoading}
                  >
                    {btnLoading ? (
                      <Spinner animation='border' variant='light' size='sm' />
                    ) : (
                      t('order-kirim')
                    )}
                  </Button>
                ) : (
                  <></>
                )}
              </div>
            </div>
          )}
        </div>
      ) : roleUser == 'finance' ? (
        <div>
          {loading ? (
            <div className='d-flex justify-content-center py-10'>
              <div className='lds-ellipsis'>
                <div></div>
                <div></div>
                <div></div>
                <div></div>
              </div>
            </div>
          ) : (
            <>
              <div className='card mb-4'>
                <div className='card-body'>
                  <Row className='rounded'>
                    <Col md={6}>
                      <div className='d-flex justify-content-between align-items-center mb-4'>
                        <Form.Label className='me-2'>{t('Customer Name')}</Form.Label>
                        <Form.Control
                          aria-label='Default example'
                          style={{width: '70%'}}
                          value={customerName}
                          disabled
                        />
                      </div>
                      <div className='d-flex justify-content-between align-items-center mb-4'>
                        <Form.Label className='me-2'>{t('Customer Number')}</Form.Label>
                        <Form.Control
                          aria-label='Default example'
                          style={{width: '70%'}}
                          value={customerCode}
                          disabled
                        />
                      </div>
                      <div className='d-flex justify-content-between align-items-center'>
                        <Form.Label className='me-2'>{t('Address')}</Form.Label>
                        <Form.Control
                          aria-label='Default example'
                          as='textarea'
                          style={{width: '70%', minHeight: '40px', height: 'auto'}}
                          value={customerAddress}
                          disabled
                        />
                      </div>
                    </Col>

                    <Col md={6}>
                      <div className='d-flex justify-content-between align-items-center mb-4'>
                        <Form.Label className='me-2'>{t('Phone Number')}</Form.Label>
                        <Form.Control
                          aria-label='Default example'
                          style={{width: '70%'}}
                          value={phoneNumber}
                          disabled
                        />
                      </div>
                      <div className='d-flex justify-content-between align-items-center mb-4'>
                        <Form.Label className='me-2'>{t('Email')}</Form.Label>
                        <Form.Control
                          aria-label='Default example'
                          style={{width: '70%'}}
                          value={emailCust}
                          disabled
                        />
                      </div>
                      <div className='d-flex justify-content-between align-items-center'>
                        <Form.Label className='me-2'>{t('PIC Customer')}</Form.Label>
                        <Form.Control
                          aria-label='Default example'
                          style={{width: '70%'}}
                          value={PICCust}
                          disabled
                        />
                      </div>
                    </Col>
                  </Row>
                </div>
              </div>

              <div className='card'>
                <div className='card-body'>
                  <Row>
                    <Col md={6}>
                      <div className='d-flex justify-content-between align-items-center mb-4'>
                        <Form.Label className='me-2'>Sales Org</Form.Label>
                        <Form.Control
                          aria-label='Default example'
                          style={{width: '70%'}}
                          value={produsen}
                          disabled
                        />
                      </div>
                      <div className='d-flex justify-content-between align-items-center mb-4'>
                        <Form.Label className='me-2'>{t('Findoc Type')}</Form.Label>
                        <Form.Control
                          aria-label='Default example'
                          style={{width: '70%'}}
                          value={namaJenisFindoc}
                          disabled
                        />
                      </div>
                      {jenisFindoc == 'skbdn' ? (
                        <div className='d-flex justify-content-between align-items-center mb-4'>
                          <Form.Label className='me-2'>{t('Skbdn Type')}</Form.Label>
                          <Form.Control
                            aria-label='Default example'
                            style={{width: '70%'}}
                            value={textcondition('skbdn', skbn)}
                            disabled
                          />
                        </div>
                      ) : (
                        ''
                      )}

                      <div className='d-flex justify-content-between align-items-center mb-4'>
                        <Form.Label className='me-2'>
                          {t('Findoc Number')}
                        </Form.Label>
                        <Form.Control
                          type='text'
                          placeholder={t('Enter Findoc Num')}
                          style={{width: '70%'}}
                          value={noFindoc}
                          disabled
                        />
                      </div>
                      <div className='d-flex justify-content-between align-items-center mb-4'>
                        <Form.Label className='me-2'>
                          {t('Ext Findoc Number')}
                          <span className='text-danger'>
                            *
                          </span>
                        </Form.Label>
                        <Form.Control
                          type='text'
                          placeholder={t('Ext Findoc Number')}
                          style={{width: '70%'}}
                          defaultValue={extnoFindoc}
                          disabled={approveState || status == 5 ? false : true}
                          onChange={(e: any) => setExtNoFindoc(e.target.value)}
                        />
                      </div>
                      <div className='d-flex justify-content-between align-items-center mb-4 w-100'>
                        <Form.Label className='' style={{width: (skpp && (sectorId == 2) && (jenisFindoc == 'df')) ? '35%' : '30%'}}>
                          {t('no skkp/lecto')}
                        </Form.Label>
                        <Form.Control
                          type='text'
                          defaultValue={skpp == null || skpp == 'null' ? '' : skpp}
                          style={{width: '70%'}}
                          disabled
                        />
                        {(skpp && (sectorId == 2) && (jenisFindoc == 'df')) && (
                          <button
                            className='btn btn-icon btn-bg-light btn-color-primary btn-active-primary btn-active-color-white ms-1 px-2'
                            data-bs-toggle='tooltip'
                            data-bs-placement='top'
                            data-bs-trigger='hover'
                            title={t('unduh')}
                            disabled={downloadingSKPP}
                            onClick={() => getSKPP(skpp)}
                          >
                            <KTSVG
                              path='/media/icons/duotune/arrow-down-square-fill.svg'
                              className='svg-icon-3'
                            />
                          </button>
                        )}
                      </div>
                      {SAP == null || SAP == 0 ? (
                        ''
                      ) : (
                        <div className='d-flex justify-content-between align-items-center mb-4'>
                          <Form.Label className='me-2'>{t('SAP Number')}</Form.Label>
                          <Form.Control
                            type='text'
                            // placeholder={t("Enter SAP Number")}
                            style={{width: '70%'}}
                            value={SAP}
                            disabled
                          />
                        </div>
                      )}
                      <div className='d-flex justify-content-between align-items-center mb-4'>
                        <Form.Label className='me-2'>
                          {t('Tanggal Findoc')}
                          <span className='text-danger' hidden={status == 5 ? false : true}>
                            *
                          </span>
                        </Form.Label>
                        <div style={{width: '70%'}}>
                          {(status === 5 || approveState) ? (
                            <>
                              <input
                                type='date'
                                defaultValue={finDate}
                                onChange={(date: any) => {
                                  setFinDate(date.target.value)
                                  setTglFindoc(date.target.value)
                                }}
                                className='form-control'
                              />
                            </>
                          ) : (
                            <>
                              <Form.Control
                                type='text'
                                className='form-control'
                                value={dateformat(tanggalFindoc3)}
                                disabled
                              />
                            </>
                          )}
                        </div>
                        {/* <Form.Control
                      style={{width: '70%'}}
                      disabled
                      value={tanggalFindoc?.slice(0, 10)}
                    /> */}
                      </div>
                      {/* <div className='d-flex justify-content-between align-items-center mb-4'>
                  <Form.Label className='me-2'>{t('Findoc Name')}<span className='text-danger'>*</span></Form.Label>
                  <Form.Control
                    type='text'
                    placeholder={t("Masukkan Nama Findoc")}
                    style={{ width: "70%" }}
                    disabled
                    value={namaFindoc}
                  />
                </div> */}
                      <div className='d-flex justify-content-between align-items-center mb-4'>
                        <Form.Label className='me-2'>
                          {t('Findoc Desc')}
                          <span className='text-danger'>
                            *
                          </span>
                        </Form.Label>
                        <Form.Control
                          type='text'
                          placeholder={t("Enter Findoc Desc")}
                          defaultValue={findocDesc}
                          style={{width: '70%'}}
                          disabled={approveState || status == 5 ? false : true}
                          onChange={(e: any) => setFindocDesc(e.target.value)}
                        />
                      </div>
                      <div className='d-flex justify-content-between align-items-center mb-4'>
                        <Form.Label className='me-2'>
                          {t('Bank Country')}
                          <span hidden={approveState ? false : true} className='text-danger'>
                            *
                          </span>
                        </Form.Label>
                        <Form.Select
                          placeholder={t('Bank Country')}
                          style={{width: '70%'}}
                          disabled={approveState ? false : true}
                          onChange={(e: any) => {
                            separator(e.target.value, setNegara, setNegaraDesc)
                            setBankKey('')
                            setBank('')
                          }}
                        >
                          {approveState ? (
                            <>
                              <option selected>
                                {t('pilih')} {t('Bank Country')}
                              </option>
                              {Country.dataCountry.map((item: any) => {
                                return (
                                  <>
                                    {negaraDesc == item.name ? (
                                      <option selected value={item.code + ',' + item.name}>
                                        {item.name}
                                      </option>
                                    ) : (
                                      <option value={item.code + ',' + item.name}>
                                        {item.name}
                                      </option>
                                    )}
                                  </>
                                )
                              })}
                            </>
                          ) : (
                            <option selected>{negaraDesc}</option>
                          )}
                        </Form.Select>
                      </div>
                      <div className='d-flex justify-content-between align-items-center mb-4'>
                        <Form.Label className='me-2'>
                          Bank Key
                          <span hidden={approveState ? false : true} className='text-danger'>
                            *
                          </span>
                        </Form.Label>
                        <div className='d-flex' style={{width: '70%'}}>
                          <Form.Control
                            type='text'
                            className='me-1 w-100'
                            disabled
                            placeholder={approveState ? 'Bank Key' : ''}
                            value={bank}
                          />
                          <Button
                            className='btn btn-primary d-flex justify-content-center align-items-center'
                            data-bs-toggle='tooltip'
                            data-bs-placement='top'
                            data-bs-trigger='hover'
                            title={t('telusuri')}
                            onClick={() => setShowBank(true)}
                            disabled={negara != '' && approveState ? false : true}
                          >
                            <KTSVG
                              path='/media/icons/duotune/browse.svg'
                              className='svg-icon-3 ms-2'
                            />
                          </Button>
                        </div>
                      </div>

                      <div className='d-flex justify-content-between align-items-center mb-4'>
                        <Form.Label style={{width: '30%'}}>
                          {t('Finance doc. value')}
                          <span className='text-danger'>
                            *
                          </span>
                        </Form.Label>
                        {approveState || status === 5 ? (
                          <CurrencyInput
                            style={{width: '70%'}}
                            key={i18next.language}
                            className='form-control'
                            placeholder={approveState ? t('Finance doc. value') : ''}
                            defaultValue={nilai}
                            decimalSeparator={i18next.language === 'en' ? '.' : ','}
                            groupSeparator={i18next.language === 'en' ? ',' : '.'}
                            onValueChange={(e: any) => {
                              setNilai(e?.replace(/,/g, '.'))
                            }}
                            decimalsLimit={2}
                          />
                        ) : (
                          <Form.Control
                            type='text'
                            style={{width: '70%'}}
                            disabled
                            value={
                              i18next.language === 'en'
                                ? nilai?.toLocaleString('en', {maximumFractionDigits: 4})
                                : nilai?.toLocaleString('id', {maximumFractionDigits: 4})
                            }
                          />
                        )}

                        {/* <Form.Control
                    type='number'
                    placeholder={i18next.language === 'en' ? nilai?.toLocaleString('en', { maximumFractionDigits: 4 }) : nilai?.toLocaleString('id', { maximumFractionDigits: 4 })}
                    style={{ width: "70%" }}
                    disabled={approveState ? false : true}
                    onChange={(e: any) => setNilai(parseInt(e.target.value))}
                  /> */}
                      </div>

                      <div className='d-flex justify-content-between align-items-center mb-4'>
                        <Form.Label style={{width: '30%'}}>
                          {t('Terms of Payment')}
                          <span
                            hidden={approveState || status == 5 ? false : true}
                            className='text-danger'
                          >
                            *
                          </span>
                        </Form.Label>
                        <Form.Select
                          aria-label='Default select example'
                          style={{width: '70%'}}
                          disabled={approveState || status == 5 ? false : true}
                          onChange={(e: any) => setTOP(e.target.value)}
                        >
                          <option>
                            {t('pilih')} {t('Terms of Payment')}
                          </option>
                          <option
                            selected={approveState || status == 5 ? false : true}
                            hidden
                          ></option>
                          {fullTOP.map((item: any) => {
                            return (
                              <>
                                {TOP == item.code ? (
                                  <option selected value={item.code}>
                                    {item.top_desc}
                                  </option>
                                ) : (
                                  <option value={item.code}>{item.top_desc}</option>
                                )}
                              </>
                            )
                          })}
                        </Form.Select>
                      </div>
                      <div className='d-flex justify-content-between align-items-center mb-4'>
                        <Form.Label className='me-2'>{t('order-lampiran')}</Form.Label>
                        <Button
                          variant='primary'
                          onClick={() => {
                            setShowUpload(true)
                            ambilAttachment(idItem)
                          }}
                        >
                          {t('order-lampiran')}
                        </Button>
                      </div>
                    </Col>
                    <Col md={6}>
                      <div className='d-flex justify-content-between align-items-center mb-4'>
                        <Form.Label className='me-2'>{t('sub-order-sektor')}</Form.Label>
                        <Form.Control
                          defaultValue={t(sektordesc)}
                          style={{width: '70%'}}
                          disabled
                        />
                      </div>

                      <div className='d-flex justify-content-between align-items-center mb-4'>
                        <Form.Label className='me-2'>{t('mataUang')}</Form.Label>
                        {
                          ((negara != 'ID' && negara != null) || jenisFindoc == 'lc') ? (
                            <Form.Control type='text' disabled value='USD' style={{width: '70%'}} />
                          ) : (
                            <Form.Control type='text' disabled value='IDR' style={{width: '70%'}} />
                        )}
                      </div>
                      <div className='d-flex justify-content-between align-items-center mb-4'>
                        <Form.Label className='me-2'>
                          {t('Valid Start Date')}
                          <span hidden={approveState ? false : true} className='text-danger'>
                            *
                          </span>
                        </Form.Label>
                        {approveState ? (
                          <Form.Control
                            type='Date'
                            defaultValue={dari}
                            style={{width: '70%'}}
                            onChange={(e: any) => setFrom(e.target.value)}
                          />
                        ) : (
                          <Form.Control disabled style={{width: '70%'}} value={dateformat(dari)} />
                        )}
                      </div>
                      <div className='d-flex justify-content-between align-items-center mb-4'>
                        <Form.Label className='me-2'>
                          {t('valid End Date')}
                          <span className='text-danger'>
                            *
                          </span>
                        </Form.Label>
                        <Form.Control
                          type='Date'
                          defaultValue={berlaku}
                          style={{width: '70%'}}
                          disabled={approveState || status == 5 ? false : true}
                          onChange={(e: any) => setBerlaku(e.target.value)}
                        />
                        {/* {approveState ? (
                        ) : (
                          <Form.Control
                            disabled
                            style={{width: '70%'}}
                            value={dateformat(berlaku)}
                          />
                        )} */}
                      </div>
                      <div className='d-flex justify-content-between align-items-center mb-4'>
                        <Form.Label className='me-2'>
                          Incoterm
                          <span className='text-danger' hidden={approveState ? false : true}>
                            *
                          </span>
                        </Form.Label>
                        <Form.Select
                          aria-label='Default select example'
                          style={{width: '70%'}}
                          onChange={(e: any) => setIncoterm(e.target.value)}
                          disabled={approveState ? false : true}
                        >
                          <option>{t('pilih')} Incoterm</option>
                          <option selected={approveState ? false : true} hidden></option>
                          {fullIncoterm.map((item: any) => {
                            return (
                              <>
                                {item.id == incoterm ? (
                                  <option selected value={item.id}>
                                    {item.code}
                                  </option>
                                ) : (
                                  <option value={item.id}>{item.code}</option>
                                )}
                              </>
                            )
                          })}
                        </Form.Select>
                      </div>
                      <div className='d-flex justify-content-between align-items-center mb-4'>
                        <Form.Label className='me-2'>
                          Incoterm 2
                          <span className='text-danger' hidden={approveState ? false : true} >
                            *
                          </span>
                        </Form.Label>
                        <Form.Control
                          style={{width: '70%'}}
                          defaultValue={incoterm2}
                          placeholder='Incoterm 2'
                          disabled={approveState ? false : true}
                          onChange={(e: any) => setIncoterm2(e.target.value)}
                        />
                      </div>
                      <div className='d-flex justify-content-between align-items-center mb-2'>
                        <Form.Label className='me-2'>{t('uangSaku')}</Form.Label>
                        {approveState ? (
                          <InputGroup style={{width: '70%'}}>
                          <CurrencyInput
                            className='form-control form-control-sm'
                            value={
                              i18next.language === 'en'
                                ? uang?.toLocaleString('en', {maximumFractionDigits: 2})
                                : uang?.toLocaleString('id', {maximumFractionDigits: 2})
                            }
                            disabled={approveState ? false : true}
                            placeholder={t('uangSaku')}
                            decimalSeparator={language === 'en' ? '.' : ','}
                            groupSeparator={language === 'en' ? ',' : '.'}
                            onValueChange={(value: any) => {
                              let _value = value?.replace(/,/g, '.')
                              if(_value > 100) _value = 100
                              setUang(_value)
                            }}
                            max={100}
                            decimalsLimit={2}
                          />
                          <InputGroup.Text id='basic-addon2'>%</InputGroup.Text>
                        </InputGroup>
                          // <InputGroup style={{width: '70%'}}>
                          //   <Form.Control
                          //     type='text'
                          //     placeholder={t('uangSaku')}
                          //     defaultValue={
                          //       i18next.language === 'en'
                          //         ? uang?.toLocaleString('en', {maximumFractionDigits: 4})
                          //         : uang?.toLocaleString('id', {maximumFractionDigits: 4})
                          //     }
                          //     disabled={approveState ? false : true}
                          //     onChange={(e: any) => setUang(e.target.value)}
                          //   />
                          //   <InputGroup.Text id='basic-addon2'>%</InputGroup.Text>
                          // </InputGroup>
                        ) : (
                          <InputGroup style={{width: '70%'}}>
                            <CurrencyInput
                              className='form-control form-control-sm'
                              value={
                                i18next.language === 'en'
                                  ? uang?.toLocaleString('en', {maximumFractionDigits: 2})
                                  : uang?.toLocaleString('id', {maximumFractionDigits: 2})
                              }
                              disabled={approveState ? false : true}
                              placeholder={t('uangSaku')}
                              decimalSeparator={language === 'en' ? '.' : ','}
                              groupSeparator={language === 'en' ? ',' : '.'}
                              onValueChange={(value: any) => {
                                let _value = value?.replace(/,/g, '.')
                                if(_value > 100) _value = 100
                                setUang(_value)
                              }}
                              max={100}
                              decimalsLimit={2}
                            />
                            <InputGroup.Text id='basic-addon2'>%</InputGroup.Text>
                          </InputGroup>
                          // <Form.Control
                          //   type='text'
                          //   style={{width: '70%'}}
                          //   defaultValue={
                          //     uang == null
                          //       ? '0%'
                          //       : i18next.language === 'en'
                          //       ? uang?.toLocaleString('en', {maximumFractionDigits: 4}) + '%'
                          //       : uang?.toLocaleString('id', {maximumFractionDigits: 4}) + '%'
                          //   }
                          //   disabled={approveState ? false : true}
                          //   onChange={(e: any) => setUang(e.target.value)}
                          // />
                        )}
                      </div>
                      {/* <div className='d-flex justify-content-between align-items-center mb-4'>
                    <Form.Label className='me-2'>Residual Deposit</Form.Label>
                    <Form.Control
                      placeholder={t('Enter Allowance')}
                      style={{ width: "70%" }}
                      disabled
                      value={residual?.toLocaleString()}
                    />
                  </div>
                  <div className='d-flex justify-content-between align-items-center mb-4'>
                    <Form.Label className='me-2'>Used Deposit</Form.Label>
                    <Form.Control
                      placeholder={t('Enter Allowance')}
                      style={{ width: "70%" }}
                      disabled
                      value={used?.toLocaleString()}
                    />
                  </div> */}
                      {/* {hardcopy ? (
                  <div className='d-flex justify-content-between align-items-center mb-8 mt-8'>
                    <Form.Label className='me-2'>{t('pengirimanHardCopy')}</Form.Label>
                    <Form.Check reverse name='hardCopy' type='checkbox' disabled checked={hardcopy} />
                  </div>
                ) : ''} */}

                      <div className='d-flex justify-content-between align-items-center mb-4 w-100'>
                        <Form.Label className='' style={{width: '30%'}}>
                          {t('Latest Shipment Date')}
                          <span className='text-danger'>
                            *
                          </span>
                        </Form.Label>
                        <Form.Control
                          type='Date'
                          defaultValue={batas}
                          style={{width: '70%'}}
                          disabled={approveState || status == 5 ? false : true}
                          onChange={(e: any) => setBatas(e.target.value)}
                        />
                        {/* {approveState ? (
                        ) : (
                          <Form.Control disabled style={{width: '70%'}} value={dateformat(batas)} />
                        )} */}
                      </div>

                      <div className='d-flex justify-content-between align-items-center mb-4'>
                        <Form.Label className='me-2'>{t('receipt_date')}</Form.Label>
                        {approveState ? (
                          <input
                            type='date'
                            defaultValue={receiptDate}
                            style={{width: '70%'}}
                            onChange={(date: any) => {
                              setReceiptDate(date.target.value)
                            }}
                            className='form-control'
                          />
                        ) : (
                          <Form.Control
                            disabled
                            style={{width: '70%'}}
                            value={dateformat(receiptDate)}
                          />
                        )}
                      </div>

                      <div className='d-flex justify-content-between align-items-center mb-4'>
                        <Form.Label className='me-2'>{t('last_date_bol')}</Form.Label>
                        <Form.Control
                          type='date'
                          defaultValue={lastDateBol}
                          onChange={(date: any) => {
                            setLastDateBol(date.target.value)
                          }}
                          style={{width: '70%'}}
                          disabled={approveState || status == 5 ? false : true}
                          className='form-control'
                        />
                        {/* {approveState ? (
                        ) : (
                          <Form.Control
                            disabled
                            style={{width: '70%'}}
                            value={dateformat(lastDateBol)}
                          />
                        )} */}
                      </div>

                      <div className='d-flex justify-content-between align-items-center mb-4'>
                        <Form.Label style={{width: '30%'}}>{t('presentation_date')}</Form.Label>
                        {approveState ? (
                          <input
                            type='date'
                            defaultValue={presentationDate}
                            onChange={(date: any) => {
                              setPresentationDate(date.target.value)
                            }}
                            style={{width: '70%'}}
                            className='form-control'
                          />
                        ) : (
                          <Form.Control
                            disabled
                            style={{width: '70%'}}
                            value={dateformat(presentationDate)}
                          />
                        )}
                      </div>

                      <div className='d-flex justify-content-between align-items-center mb-4'>
                        <Form.Label className='me-2'>{t('opening_date')}</Form.Label>
                        {approveState ? (
                          <input
                            type='date'
                            defaultValue={openingDate}
                            onChange={(date: any) => {
                              setOpeningDate(date.target.value)
                            }}
                            style={{width: '70%'}}
                            className='form-control'
                          />
                        ) : (
                          <Form.Control
                            disabled
                            style={{width: '70%'}}
                            value={dateformat(openingDate)}
                          />
                        )}
                      </div>

                      <div className='d-flex justify-content-between align-items-center mb-4'>
                        <Form.Label className='me-2'>{t('Ship-to Party')}</Form.Label>
                        <Form.Check
                          reverse
                          disabled={approveState ? false : true}
                          className='mt-5 mb-2'
                          type='checkbox'
                          id='ckbox-ship'
                          defaultChecked={ship}
                          onClick={() => setShip(!ship)}
                        />
                      </div>
                      {ship ? (
                        <div className='d-flex justify-content-between align-items-center mb-4'>
                          <Form.Label className='me-2'></Form.Label>
                          <div className='d-flex' style={{width: '70%'}}>
                            <Form.Control
                              type='text'
                              size='sm'
                              className='w-100'
                              disabled
                              placeholder={approveState ? 'Search' + ' ' + t('Customer') : ''}
                              value={
                                approveState
                                  ? customerID == ''
                                    ? ''
                                    : customerID + ' - ' + titleCustomer + ' ' + customer
                                  : shipCust
                              }
                              style={{width: '70%'}}
                            />
                            {approveState ? (
                              <Button
                                className='btn btn-primary d-flex justify-content-center align-items-center ms-1'
                                data-bs-toggle='tooltip'
                                data-bs-placement='top'
                                data-bs-trigger='hover'
                                title={t('telusuri')}
                                onClick={() => handleCustomer()}
                              >
                                <KTSVG
                                  path='/media/icons/duotune/browse.svg'
                                  className='svg-icon-3 ms-2'
                                />
                              </Button>
                            ) : (
                              <></>
                            )}
                          </div>
                        </div>
                      ) : (
                        <></>
                      )}

                      <div className='d-flex justify-content-between align-items-center mb-4'>
                        <Form.Label className='me-2'>File Findoc</Form.Label>
                        {fileName ? (
                          <a href={file} download className='btn btn-primary align-items-center' target='blank'>
                            {t('Download')}
                          </a>
                        ) : (
                            <button className='btn btn-primary align-items-center' disabled>
                              {t('Download')}
                            </button>
                        )}
                        {/* <Button className='primary' onClick={() => window.open(file)}>
                          {t('Download')}
                        </Button> */}
                      </div>

                      <div className='d-flex justify-content-between align-items-center mb-4'>
                        <Form.Label className='me-2'>{t('Keterangan')}</Form.Label>
                        <Form.Control
                          as='textarea'
                          defaultValue={
                            keterangan == null || keterangan == 'null' ? '' : keterangan
                          }
                          style={{width: '70%', height: '40px'}}
                          disabled={approveState || status == 5 ? false : true}
                          onChange={(e: any) => setKeterangan(e.target.value)}
                        />
                      </div>
                    </Col>
                  </Row>

                  <div className='d-flex align-items-center justify-content-end mt-5'>
                    <Link to={'/financial'}>
                      <button className='btn btn-secondary me-2'>
                        {status == 4 ? t('cancel') : t('order-kembali')}
                      </button>
                    </Link>
                    <button
                      className='btn me-2 btn-info'
                      // style={{backgroundColor: '#274070', color: '#fff'}}
                      onClick={() => setShowCommentCust(true)}
                    >
                      {t('Chat')}
                    </button>
                    {approveState == true || (status == 5 && hakAkses?.update) ? (
                      <>
                        <button
                          hidden={status == 5 ? true : false}
                          className='btn btn-danger me-2'
                          onClick={() => setShowReject(true)}
                        >
                          {t('order-tolak')}
                        </button>
                        <Modal
                          show={showReject}
                          onHide={() => setShowReject(false)}
                          centered
                          backdrop='static'
                        >
                          <Modal.Header closeButton>
                            <Modal.Title>{t('order-tolak')} Findoc</Modal.Title>
                          </Modal.Header>
                          <Modal.Body>
                            <FloatingLabel controlId='floatingTextarea2' label={t('order-alasan')}>
                              <Form.Control
                                as='textarea'
                                placeholder={t('Tinggal-pesan')}
                                style={{height: '100px'}}
                                onChange={(e: any) => setRejectNote(e.target.value)}
                              />
                            </FloatingLabel>
                          </Modal.Body>
                          <Modal.Footer>
                            <Button variant='secondary' onClick={() => setShowReject(false)}>
                              {t('cancel')}
                            </Button>
                            <Button variant='danger' onClick={() => Reject()} disabled={btnLoading}>
                              {btnLoading ? (
                                <Spinner animation='border' variant='light' size='sm' />
                              ) : (
                                t('order-tolak')
                              )}
                            </Button>
                          </Modal.Footer>
                        </Modal>

                        <button
                          hidden={status == 5 ? true : false}
                          className='btn btn-warning me-2'
                          onClick={() => setShowRevision(true)}
                        >
                          {t('Revision')}
                        </button>
                        <Modal
                          show={showRevision}
                          onHide={() => setShowRevision(false)}
                          centered
                          backdrop='static'
                        >
                          <Modal.Header closeButton>
                            <Modal.Title>{t('Revise')} Findoc</Modal.Title>
                          </Modal.Header>
                          <Modal.Body>
                            <FloatingLabel controlId='floatingTextarea2' label={t('order-alasan')}>
                              <Form.Control
                                as='textarea'
                                placeholder={t('Tinggal-pesan')}
                                style={{height: '100px'}}
                                onChange={(e: any) => setRevisionNote(e.target.value)}
                              />
                            </FloatingLabel>
                          </Modal.Body>
                          <Modal.Footer>
                            <Button variant='secondary' onClick={() => setShowRevision(false)}>
                              {t('cancel')}
                            </Button>
                            <Button
                              variant='warning'
                              onClick={() => Revision()}
                              disabled={btnLoading}
                            >
                              {btnLoading ? (
                                <Spinner animation='border' variant='light' size='sm' />
                              ) : (
                                t('Revise')
                              )}
                            </Button>
                          </Modal.Footer>
                        </Modal>

                        <button
                          className='btn btn-success me-2'
                          onClick={() => {
                            setShowApprove(true)
                            setShowComment(false)
                            setComment('')
                          }}
                        >
                          {status == 5 ? t('ubah') : t('setujui')}
                        </button>
                        <Modal
                          show={showApprove}
                          onHide={() => setShowApprove(false)}
                          centered
                          backdrop='static'
                        >
                          <Modal.Header closeButton>
                            <Modal.Title>{t('Menyetujui')} Findoc</Modal.Title>
                          </Modal.Header>
                          <Modal.Body>
                            {showComment ? (
                              <>
                                <FloatingLabel controlId='floatingTextarea2' label={t('Comment')}>
                                  <Form.Control
                                    as='textarea'
                                    placeholder={t('Tinggal-pesan')}
                                    style={{height: '100px'}}
                                    onChange={(e: any) => setComment(e.target.value)}
                                  />
                                </FloatingLabel>
                              </>
                            ) : (
                              <p className='text-center fw-bold fs-4'>{t('Approve')}?</p>
                            )}
                          </Modal.Body>

                          <Modal.Footer>
                            <Button
                              className='btn btn-secondary me-2'
                              onClick={() => setShowApprove(false)}
                            >
                              {t('Tidak')}
                            </Button>
                            <Button
                              className='btn btn-success'
                              onClick={() => Approve()}
                              disabled={btnLoading}
                            >
                              {btnLoading ? (
                                <Spinner animation='border' variant='light' size='sm' />
                              ) : (
                                t('Ya')
                              )}
                            </Button>
                          </Modal.Footer>
                        </Modal>
                      </>
                    ) : (
                      <></>
                    )}

                    {(hakAkses?.update && SAP) && (
                      <Button
                          className='btn btn-primary'
                          onClick={() => handleSyncSAP()}
                          disabled={loadingBtnSync}
                        >
                          Sync SAP
                      </Button>
                    )}
                  </div>
                </div>
              </div>
            </>
          )}
        </div>
      ) : (
        <>
          <div className='card'>
            {loading ? (
              <div className='d-flex justify-content-center py-10'>
                <div className='lds-ellipsis'>
                  <div></div>
                  <div></div>
                  <div></div>
                  <div></div>
                </div>
              </div>
            ) : (
              <div className='card-body'>
                {status == 5 ? (
                  <Row>
                    <Col md={6}>
                      <div className='d-flex justify-content-between align-items-center mb-4'>
                        <Form.Label className='me-2'>Sales Org</Form.Label>
                        <Form.Control
                          aria-label='Default example'
                          style={{width: '70%'}}
                          value={produsen}
                          disabled
                        />
                      </div>
                      <div className='d-flex justify-content-between align-items-center mb-4'>
                        <Form.Label className='me-2'>{t('Findoc Type')}</Form.Label>
                        <Form.Control
                          aria-label='Default example'
                          style={{width: '70%'}}
                          value={namaJenisFindoc}
                          disabled
                        />
                      </div>
                      {jenisFindoc == 'skbdn' ? (
                        <div className='d-flex justify-content-between align-items-center mb-4'>
                          <Form.Label className='me-2'>{t('Skbdn Type')}</Form.Label>
                          <Form.Control
                            aria-label='Default example'
                            style={{width: '70%'}}
                            value={textcondition('skbdn', skbn)}
                            disabled
                          />
                        </div>
                      ) : (
                        ''
                      )}

                      <div className='d-flex justify-content-between align-items-center mb-4'>
                        <Form.Label className='me-2'>{t('Findoc Number')}</Form.Label>
                        <Form.Control
                          type='text'
                          placeholder={t('Enter Findoc Num')}
                          style={{width: '70%'}}
                          value={noFindoc}
                          disabled
                        />
                      </div>
                      <div className='d-flex justify-content-between align-items-center mb-4'>
                        <Form.Label className='me-2'>{t('Ext Findoc Number')}</Form.Label>
                        <Form.Control
                          type='text'
                          // placeholder={t('Ext Findoc Number')}
                          style={{width: '70%'}}
                          value={extnoFindoc}
                          disabled
                        />
                      </div>
                      <div className='d-flex justify-content-between align-items-center mb-4 w-100'>
                        <Form.Label className='' style={{width: (skpp && (sectorId == 2) && (jenisFindoc == 'df')) ? '35%' : '30%'}}>
                          {t('no skkp/lecto')}
                        </Form.Label>
                        <Form.Control
                          type='text'
                          defaultValue={skpp == null || skpp == 'null' ? '' : skpp}
                          style={{width: '70%'}}
                          disabled
                        />
                        {(skpp && (sectorId == 2) && (jenisFindoc == 'df')) && (
                          <button
                            className='btn btn-icon btn-bg-light btn-color-primary btn-active-primary btn-active-color-white ms-1 px-2'
                            data-bs-toggle='tooltip'
                            data-bs-placement='top'
                            data-bs-trigger='hover'
                            title={t('unduh')}
                            disabled={downloadingSKPP}
                            onClick={() => getSKPP(skpp)}
                          >
                            <KTSVG
                              path='/media/icons/duotune/arrow-down-square-fill.svg'
                              className='svg-icon-3'
                            />
                          </button>
                        )}
                      </div>
                      {SAP == null || SAP == 0 ? (
                        ''
                      ) : (
                        <div className='d-flex justify-content-between align-items-center mb-4'>
                          <Form.Label className='me-2'>{t('SAP Number')}</Form.Label>
                          <Form.Control
                            type='text'
                            // placeholder={t("Enter SAP Number")}
                            style={{width: '70%'}}
                            value={SAP}
                            disabled
                          />
                        </div>
                      )}
                      <div className='d-flex justify-content-between align-items-center mb-4'>
                        <Form.Label className='me-2'>{t('Tanggal Findoc')}</Form.Label>
                        <div style={{width: '70%'}}>
                          <Form.Control
                            type='text'
                            className='form-control'
                            value={dateformat(tanggalFindoc3)}
                            disabled
                          />
                        </div>
                      </div>

                      <div className='d-flex justify-content-between align-items-center mb-4'>
                        <Form.Label className='me-2'>{t('Findoc Desc')}</Form.Label>
                        <Form.Control
                          type='text'
                          // placeholder={t("Enter Findoc Desc")}
                          defaultValue={findocDesc}
                          style={{width: '70%'}}
                          disabled
                        />
                      </div>
                      <div className='d-flex justify-content-between align-items-center mb-4'>
                        <Form.Label className='me-2'>
                          {t('Bank Country')}
                          <span hidden={approveState ? false : true} className='text-danger'>
                            *
                          </span>
                        </Form.Label>
                        <Form.Select
                          placeholder={t('Bank Country')}
                          style={{width: '70%'}}
                          disabled={approveState ? false : true}
                          onChange={(e: any) => {
                            separator(e.target.value, setNegara, setNegaraDesc)
                            setBankKey('')
                            setBank('')
                          }}
                        >
                          {approveState ? (
                            <>
                              <option selected>
                                {t('pilih')} {t('Bank Country')}
                              </option>
                              {Country.dataCountry.map((item: any) => {
                                return (
                                  <>
                                    {negaraDesc == item.name ? (
                                      <option selected value={item.code + ',' + item.name}>
                                        {item.name}
                                      </option>
                                    ) : (
                                      <option value={item.code + ',' + item.name}>
                                        {item.name}
                                      </option>
                                    )}
                                  </>
                                )
                              })}
                            </>
                          ) : (
                            <option selected>{negaraDesc}</option>
                          )}
                        </Form.Select>
                      </div>
                      <div className='d-flex justify-content-between align-items-center mb-4'>
                        <Form.Label className='me-2'>Bank Key</Form.Label>
                        <div className='d-flex' style={{width: '70%'}}>
                          <Form.Control
                            type='text'
                            className='me-1 w-100'
                            disabled
                            placeholder={approveState ? 'Bank Key' : ''}
                            value={bank}
                          />
                        </div>
                      </div>

                      <div className='d-flex justify-content-between align-items-center mb-4'>
                        <Form.Label>{t('Finance doc. value')}</Form.Label>
                        {approveState ? (
                          <CurrencyInput
                            style={{width: '70%'}}
                            className='form-control form-control-sm'
                            placeholder={approveState ? t('Finance doc. value') : ''}
                            decimalSeparator={language === 'en' ? '.' : ','}
                            groupSeparator={language === 'en' ? ',' : '.'}
                            onValueChange={(e: any) => {
                              setNilai(e)
                            }}
                            decimalsLimit={2}
                          />
                        ) : (
                          <Form.Control
                            type='text'
                            style={{width: '70%'}}
                            disabled
                            value={
                              i18next.language === 'en'
                                ? nilai?.toLocaleString('en', {maximumFractionDigits: 4})
                                : nilai?.toLocaleString('id', {maximumFractionDigits: 4})
                            }
                          />
                        )}
                      </div>

                      <div className='d-flex justify-content-between align-items-center mb-4'>
                        <Form.Label className='me-2'>{t('Terms of Payment')}</Form.Label>
                        <Form.Select
                          aria-label='Default select example'
                          style={{width: '70%'}}
                          disabled={approveState ? false : true}
                          onChange={(e: any) => setTOP(e.target.value)}
                        >
                          <option>
                            {t('pilih')} {t('Terms of Payment')}
                          </option>
                          <option selected={approveState ? false : true} hidden></option>
                          {fullTOP.map((item: any) => {
                            return (
                              <>
                                {TOP == item.code ? (
                                  <option selected value={item.code}>
                                    {item.top_desc}
                                  </option>
                                ) : (
                                  <option value={item.code}>{item.top_desc}</option>
                                )}
                              </>
                            )
                          })}
                        </Form.Select>
                      </div>

                      <div className='d-flex justify-content-between align-items-center mb-4'>
                        <Form.Label className='me-2'>File Findoc</Form.Label>
                        {fileName ? (
                          <a href={file} download className='btn btn-primary align-items-center' target='blank'>
                            {t('Download')}
                          </a>
                        ) : (
                            <button className='btn btn-primary align-items-center' disabled>
                              {t('Download')}
                            </button>
                        )}
                        {/* <Button className='primary' onClick={() => window.open(file)}>
                        {t('Download')}
                      </Button> */}
                      </div>
                    </Col>
                    <Col md={6}>
                      <div className='d-flex justify-content-between align-items-center mb-4'>
                        <Form.Label className='me-2'>{t('sub-order-sektor')}</Form.Label>
                        <Form.Control
                          defaultValue={t(sektordesc)}
                          style={{width: '70%'}}
                          disabled
                        />
                      </div>

                      <div className='d-flex justify-content-between align-items-center mb-4'>
                        <Form.Label className='me-2'>{t('mataUang')}</Form.Label>
                        {negara == 'ID' || negara == null ? (
                          <Form.Control type='text' disabled value='IDR' style={{width: '70%'}} />
                        ) : (
                          <Form.Control type='text' disabled value='USD' style={{width: '70%'}} />
                        )}
                      </div>
                      <div className='d-flex justify-content-between align-items-center mb-4'>
                        <Form.Label className='me-2'>
                          {t('Valid Start Date')}
                          <span hidden={approveState ? false : true} className='text-danger'>
                            *
                          </span>
                        </Form.Label>
                        {approveState ? (
                          <Form.Control
                            type='Date'
                            style={{width: '70%'}}
                            onChange={(e: any) => setFrom(e.target.value)}
                          />
                        ) : (
                          <Form.Control disabled style={{width: '70%'}} value={dateformat(dari)} />
                        )}
                      </div>
                      <div className='d-flex justify-content-between align-items-center mb-4'>
                        <Form.Label className='me-2'>
                          {t('valid End Date')}
                          <span hidden={approveState ? false : true} className='text-danger'>
                            *
                          </span>
                        </Form.Label>
                        {approveState ? (
                          <Form.Control
                            type='Date'
                            style={{width: '70%'}}
                            onChange={(e: any) => setBerlaku(e.target.value)}
                          />
                        ) : (
                          <Form.Control
                            disabled
                            style={{width: '70%'}}
                            value={dateformat(berlaku)}
                          />
                        )}
                      </div>
                      <div className='d-flex justify-content-between align-items-center mb-4'>
                        <Form.Label className='me-2'>
                          Incoterm
                          <span hidden={approveState ? false : true} className='text-danger'>
                            *
                          </span>
                        </Form.Label>
                        <Form.Select
                          aria-label='Default select example'
                          style={{width: '70%'}}
                          onChange={(e: any) => setIncoterm(e.target.value)}
                          disabled={approveState ? false : true}
                        >
                          <option>{t('pilih')} Incoterm</option>
                          <option selected={approveState ? false : true} hidden></option>
                          {fullIncoterm.map((item: any) => {
                            return (
                              <>
                                {item.id == incoterm ? (
                                  <option selected value={item.id}>
                                    {item.code}
                                  </option>
                                ) : (
                                  <option value={item.id}>{item.code}</option>
                                )}
                              </>
                            )
                          })}
                        </Form.Select>
                      </div>
                      <div className='d-flex justify-content-between align-items-center mb-4'>
                        <Form.Label className='me-2'>Incoterm 2</Form.Label>
                        <Form.Control
                          style={{width: '70%'}}
                          defaultValue={incoterm2}
                          placeholder='Incoterm 2'
                          disabled={approveState ? false : true}
                          onChange={(e: any) => setIncoterm2(e.target.value)}
                        />
                      </div>
                      <div className='d-flex justify-content-between align-items-center mb-2'>
                        <Form.Label className='me-2'>{t('uangSaku')}</Form.Label>
                        {approveState ? (
                          <InputGroup style={{width: '70%'}}>
                          <CurrencyInput
                            className='form-control form-control-sm'
                            value={
                              i18next.language === 'en'
                                ? uang?.toLocaleString('en', {maximumFractionDigits: 2})
                                : uang?.toLocaleString('id', {maximumFractionDigits: 2})
                            }
                            disabled={approveState ? false : true}
                            placeholder={t('uangSaku')}
                            decimalSeparator={language === 'en' ? '.' : ','}
                            groupSeparator={language === 'en' ? ',' : '.'}
                            onValueChange={(value: any) => {
                              let _value = value?.replace(/,/g, '.')
                              if(_value > 100) _value = 100
                              setUang(_value)
                            }}
                            max={100}
                            decimalsLimit={2}
                          />
                          <InputGroup.Text id='basic-addon2'>%</InputGroup.Text>
                        </InputGroup>
                          // <InputGroup style={{width: '70%'}}>
                          //   <Form.Control
                          //     type='text'
                          //     placeholder={t('uangSaku')}
                          //     defaultValue={
                          //       i18next.language === 'en'
                          //         ? uang?.toLocaleString('en', {maximumFractionDigits: 4})
                          //         : uang?.toLocaleString('id', {maximumFractionDigits: 4})
                          //     }
                          //     disabled={approveState ? false : true}
                          //     onChange={(e: any) => setUang(e.target.value)}
                          //   />
                          //   <InputGroup.Text id='basic-addon2'>%</InputGroup.Text>
                          // </InputGroup>
                        ) : (
                          <InputGroup style={{width: '70%'}}>
                            <CurrencyInput
                              className='form-control form-control-sm'
                              value={
                                i18next.language === 'en'
                                  ? uang?.toLocaleString('en', {maximumFractionDigits: 2})
                                  : uang?.toLocaleString('id', {maximumFractionDigits: 2})
                              }
                              disabled={approveState ? false : true}
                              placeholder={t('uangSaku')}
                              decimalSeparator={language === 'en' ? '.' : ','}
                              groupSeparator={language === 'en' ? ',' : '.'}
                              onValueChange={(value: any) => {
                                let _value = value?.replace(/,/g, '.')
                                if(_value > 100) _value = 100
                                setUang(_value)
                              }}
                              max={100}
                              decimalsLimit={2}
                            />
                            <InputGroup.Text id='basic-addon2'>%</InputGroup.Text>
                          </InputGroup>
                          // <Form.Control
                          //   type='text'
                          //   style={{width: '70%'}}
                          //   defaultValue={
                          //     uang == null
                          //       ? '0%'
                          //       : i18next.language === 'en'
                          //       ? uang?.toLocaleString('en', {maximumFractionDigits: 4}) + '%'
                          //       : uang?.toLocaleString('id', {maximumFractionDigits: 4}) + '%'
                          //   }
                          //   disabled={approveState ? false : true}
                          //   onChange={(e: any) => setUang(e.target.value)}
                          // />
                        )}
                      </div>

                      <div className='d-flex justify-content-between align-items-center mb-4 w-100'>
                        <Form.Label className='' style={{width: '30%'}}>
                          {t('Latest Shipment Date')}
                          <span hidden={approveState ? false : true} className='text-danger'>
                            *
                          </span>
                        </Form.Label>
                        {approveState ? (
                          <Form.Control
                            type='Date'
                            style={{width: '70%'}}
                            onChange={(e: any) => setBatas(e.target.value)}
                          />
                        ) : (
                          <Form.Control disabled style={{width: '70%'}} value={dateformat(batas)} />
                        )}
                      </div>

                      <div className='d-flex justify-content-between align-items-center mb-4'>
                        <Form.Label className='me-2'>{t('receipt_date')}</Form.Label>
                        {approveState ? (
                          <input
                            type='date'
                            defaultValue={receiptDate}
                            style={{width: '70%'}}
                            onChange={(date: any) => {
                              setReceiptDate(date.target.value)
                            }}
                            className='form-control'
                          />
                        ) : (
                          <Form.Control
                            disabled
                            style={{width: '70%'}}
                            value={dateformat(receiptDate)}
                          />
                        )}
                      </div>

                      <div className='d-flex justify-content-between align-items-center mb-4'>
                        <Form.Label className='me-2'>{t('last_date_bol')}</Form.Label>
                        {approveState ? (
                          <input
                            type='date'
                            defaultValue={lastDateBol}
                            onChange={(date: any) => {
                              setLastDateBol(date.target.value)
                            }}
                            style={{width: '70%'}}
                            className='form-control'
                          />
                        ) : (
                          <Form.Control
                            disabled
                            style={{width: '70%'}}
                            value={dateformat(lastDateBol)}
                          />
                        )}
                      </div>

                      <div className='d-flex justify-content-between align-items-center mb-4'>
                        <Form.Label className='' style={{width: '30%'}}>{t('presentation_date')}</Form.Label>
                        {approveState ? (
                          <input
                            type='date'
                            defaultValue={presentationDate}
                            onChange={(date: any) => {
                              setPresentationDate(date.target.value)
                            }}
                            style={{width: '70%'}}
                            className='form-control'
                          />
                        ) : (
                          <Form.Control
                            disabled
                            style={{width: '70%'}}
                            value={dateformat(presentationDate)}
                          />
                        )}
                      </div>

                      <div className='d-flex justify-content-between align-items-center mb-4'>
                        <Form.Label className='me-2'>{t('opening_date')}</Form.Label>
                        {approveState ? (
                          <input
                            type='date'
                            defaultValue={openingDate}
                            onChange={(date: any) => {
                              setOpeningDate(date.target.value)
                            }}
                            style={{width: '70%'}}
                            className='form-control'
                          />
                        ) : (
                          <Form.Control
                            disabled
                            style={{width: '70%'}}
                            value={dateformat(openingDate)}
                          />
                        )}
                      </div>

                      <div className='d-flex justify-content-between align-items-center mb-4'>
                        <Form.Label className='me-2'>{t('Ship-to Party')}</Form.Label>
                        <Form.Check
                          reverse
                          disabled={approveState ? false : true}
                          className='mt-5 mb-2'
                          type='checkbox'
                          id='ckbox-ship'
                          defaultChecked={ship}
                          onClick={() => setShip(!ship)}
                        />
                      </div>
                      {ship && (
                        <div className='d-flex justify-content-between align-items-center mb-4'>
                          <Form.Label className='me-2'></Form.Label>
                          <div className='d-flex' style={{width: '70%'}}>
                            <Form.Control
                              type='text'
                              size='sm'
                              className='w-100'
                              disabled
                              value={shipCust}
                              style={{width: '70%'}}
                            />
                          </div>
                        </div>
                      )}

                      <div className='d-flex justify-content-between align-items-center mb-4'>
                        <Form.Label className='me-2'>{t('Keterangan')}</Form.Label>
                        <Form.Control
                          as='textarea'
                          defaultValue={
                            keterangan == null || keterangan == 'null' ? '' : keterangan
                          }
                          style={{width: '70%', height: '40px'}}
                          disabled
                        />
                      </div>
                    </Col>
                  </Row>
                ) : (
                  <Row>
                    <Col md={6}>
                      <div className='d-flex justify-content-between align-items-center mb-4'>
                        <Form.Label className='me-2'>{t('Customer Name')}</Form.Label>
                        <Form.Control
                          aria-label='Default example'
                          style={{width: '70%'}}
                          value={customerName}
                          disabled
                        />
                      </div>
                      <div className='d-flex justify-content-between align-items-center mb-4'>
                        <Form.Label className='me-2'>{t('Customer Number')}</Form.Label>
                        <Form.Control
                          aria-label='Default example'
                          style={{width: '70%'}}
                          value={customerCode}
                          disabled
                        />
                      </div>
                      <div className='d-flex justify-content-between align-items-center mb-4'>
                        <Form.Label className='me-2'>{t('Address')}</Form.Label>
                        <Form.Control
                          aria-label='Default example'
                          as='textarea'
                          style={{width: '70%', minHeight: '40px', height: 'auto'}}
                          value={customerAddress}
                          disabled
                        />
                      </div>
                      <div className='d-flex justify-content-between align-items-center mb-4'>
                        <Form.Label className='me-2'>Sales Org</Form.Label>
                        <Form.Control
                          aria-label='Default example'
                          style={{width: '70%'}}
                          value={produsen}
                          disabled
                        />
                      </div>
                      <div className='d-flex justify-content-between align-items-center mb-4'>
                        <Form.Label className='me-2'>{t('Findoc Type')}</Form.Label>
                        <Form.Control
                          aria-label='Default example'
                          style={{width: '70%'}}
                          value={namaJenisFindoc}
                          disabled
                        />
                      </div>
                      {jenisFindoc == 'skbdn' ? (
                        <div className='d-flex justify-content-between align-items-center mb-4'>
                          <Form.Label className='me-2'>{t('Skbdn Type')}</Form.Label>
                          <Form.Control
                            aria-label='Default example'
                            style={{width: '70%'}}
                            value={textcondition('skbdn', skbn)}
                            disabled
                          />
                        </div>
                      ) : (
                        ''
                      )}
                      <div className='d-flex justify-content-between align-items-center mb-4'>
                        <Form.Label className='me-2'>{t('Ext Findoc Number')}</Form.Label>
                        <Form.Control
                          type='text'
                          // placeholder={t('Ext Findoc Number')}
                          style={{width: '70%'}}
                          value={extnoFindoc}
                          disabled
                        />
                      </div>
                      <div className='d-flex justify-content-between align-items-center mb-4'>
                        <Form.Label className='' style={{width: (skpp && (sectorId == 2) && (jenisFindoc == 'df')) ? '35%' : '30%'}}>
                          {t('no skkp/lecto')}
                        </Form.Label>
                        <Form.Control
                          type='text'
                          defaultValue={skpp == null || skpp == 'null' ? '' : skpp}
                          style={{width: '70%'}}
                          disabled
                        />
                        {(skpp && (sectorId == 2) && (jenisFindoc == 'df')) && (
                          <button
                            className='btn btn-icon btn-bg-light btn-color-primary btn-active-primary btn-active-color-white ms-1 px-2'
                            data-bs-toggle='tooltip'
                            data-bs-placement='top'
                            data-bs-trigger='hover'
                            title={t('unduh')}
                            disabled={downloadingSKPP}
                            onClick={() => getSKPP(skpp)}
                          >
                            <KTSVG
                              path='/media/icons/duotune/arrow-down-square-fill.svg'
                              className='svg-icon-3'
                            />
                          </button>
                        )}
                      </div>
                      {SAP == null || SAP == 0 ? (
                        ''
                      ) : (
                        <div className='d-flex justify-content-between align-items-center mb-4'>
                          <Form.Label className='me-2'>{t('SAP Number')}</Form.Label>
                          <Form.Control type='text' style={{width: '70%'}} value={SAP} disabled />
                        </div>
                      )}
                      <div className='d-flex justify-content-between align-items-center mb-4'>
                        <Form.Label className='me-2'>{t('order-lampiran')}</Form.Label>
                        <Button
                          variant='primary'
                          onClick={() => {
                            setShowUpload(true)
                            ambilAttachment(idItem)
                          }}
                        >
                          {t('order-lampiran')}
                        </Button>
                      </div>
                    </Col>

                    <Col md={6}>
                      <div className='d-flex justify-content-between align-items-center mb-4'>
                        <Form.Label className='me-2'>{t('Phone Number')}</Form.Label>
                        <Form.Control
                          aria-label='Default example'
                          style={{width: '70%'}}
                          value={phoneNumber}
                          disabled
                        />
                      </div>
                      <div className='d-flex justify-content-between align-items-center mb-4'>
                        <Form.Label className='me-2'>{t('Email')}</Form.Label>
                        <Form.Control
                          aria-label='Default example'
                          style={{width: '70%'}}
                          value={emailCust}
                          disabled
                        />
                      </div>
                      <div className='d-flex justify-content-between align-items-center mb-4'>
                        <Form.Label className='me-2'>{t('PIC Customer')}</Form.Label>
                        <Form.Control
                          aria-label='Default example'
                          style={{width: '70%'}}
                          value={PICCust}
                          disabled
                        />
                      </div>

                      <div className='d-flex justify-content-between align-items-center mb-4'>
                        <Form.Label className='me-2'>{t('sub-order-sektor')}</Form.Label>
                        <Form.Control
                          defaultValue={t(sektordesc)}
                          style={{width: '70%'}}
                          disabled
                        />
                      </div>

                      <div className='d-flex justify-content-between align-items-center mb-4'>
                        <Form.Label className='me-2'>{t('Tanggal Findoc')}</Form.Label>
                        <div style={{width: '70%'}}>
                          <Form.Control
                            className='form-control'
                            value={dateformat(tanggalFindoc3)}
                            disabled
                          />
                        </div>
                      </div>
                      <div className='d-flex justify-content-between align-items-center mb-4'>
                        <Form.Label className='me-2'>{t('Findoc Desc')}</Form.Label>
                        <Form.Control
                          type='text'
                          defaultValue={findocDesc}
                          style={{width: '70%'}}
                          disabled
                        />
                      </div>
                      <div className='d-flex justify-content-between align-items-center mb-4'>
                        <Form.Label className='me-2'>{t('Keterangan')}</Form.Label>
                        <Form.Control
                          style={{width: '70%', height: '40px'}}
                          as='textarea'
                          disabled
                          value={keterangan == null || keterangan == 'null' ? '' : keterangan}
                        />
                      </div>
                      <div className='d-flex justify-content-between align-items-center mb-4'>
                        <Form.Label className='me-2'>File Findoc</Form.Label>
                        {fileName ? (
                          <a href={file} download className='btn btn-primary align-items-center' target='blank'>
                            {t('Download')}
                          </a>
                        ) : (
                            <button className='btn btn-primary align-items-center' disabled>
                              {t('Download')}
                            </button>
                        )}
                      </div>
                    </Col>
                  </Row>
                )}

                <div className='d-flex align-items-center justify-content-end mt-5'>
                  <Link to={'/financial'}>
                    <button className='btn btn-secondary me-2'>{t('order-kembali')}</button>
                  </Link>
                  <button className='btn btn-info me-2' onClick={() => setShowCommentCust(true)}>
                    {t('Chat')}
                  </button>

                  {(hakAkses?.update && SAP) && (
                    <Button
                        className='btn btn-primary'
                        onClick={() => handleSyncSAP()}
                        disabled={loadingBtnSync}
                      >
                        Sync SAP
                    </Button>
                  )}  

                  {approveState ? (
                    <>
                      <button className='btn btn-danger me-2' onClick={() => setShowReject(true)}>
                        {t('order-tolak')}
                      </button>
                      <Modal
                        show={showReject}
                        onHide={() => setShowReject(false)}
                        centered
                        backdrop='static'
                      >
                        <Modal.Header closeButton>
                          <Modal.Title>{t('order-tolak')} Findoc</Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                          <FloatingLabel controlId='floatingTextarea2' label={t('order-alasan')}>
                            <Form.Control
                              as='textarea'
                              placeholder={t('Tinggal-pesan')}
                              style={{height: '100px'}}
                              onChange={(e: any) => setRejectNote(e.target.value)}
                            />
                          </FloatingLabel>
                        </Modal.Body>
                        <Modal.Footer>
                          <Button variant='secondary' onClick={() => setShowReject(false)}>
                            {t('cancel')}
                          </Button>
                          <Button variant='danger' onClick={() => Reject()} disabled={btnLoading}>
                            {btnLoading ? (
                              <Spinner animation='border' variant='light' size='sm' />
                            ) : (
                              t('order-tolak')
                            )}
                          </Button>
                        </Modal.Footer>
                      </Modal>

                      <button
                        className='btn btn-warning me-2'
                        onClick={() => setShowRevision(true)}
                      >
                        {t('Revision')}
                      </button>
                      <Modal
                        show={showRevision}
                        onHide={() => setShowRevision(false)}
                        centered
                        backdrop='static'
                      >
                        <Modal.Header closeButton>
                          <Modal.Title>{t('Revise')} Findoc</Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                          <FloatingLabel controlId='floatingTextarea2' label={t('order-alasan')}>
                            <Form.Control
                              as='textarea'
                              placeholder={t('Tinggal-pesan')}
                              style={{height: '100px'}}
                              onChange={(e: any) => setRevisionNote(e.target.value)}
                            />
                          </FloatingLabel>
                        </Modal.Body>
                        <Modal.Footer>
                          <Button variant='secondary' onClick={() => setShowRevision(false)}>
                            {t('cancel')}
                          </Button>
                          <Button
                            variant='warning'
                            onClick={() => Revision()}
                            disabled={btnLoading}
                          >
                            {btnLoading ? (
                              <Spinner animation='border' variant='light' size='sm' />
                            ) : (
                              t('Revisi')
                            )}
                          </Button>
                        </Modal.Footer>
                      </Modal>

                      <button
                        className='btn btn-success me-2'
                        onClick={() => {
                          setShowApprove(true)
                          setShowComment(false)
                          setComment('')
                        }}
                      >
                        {t('setujui')}
                      </button>
                      <Modal
                        show={showApprove}
                        onHide={() => setShowApprove(false)}
                        centered
                        backdrop='static'
                      >
                        <Modal.Header closeButton>
                          <Modal.Title>{t('Menyetujui')} Findoc</Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                          {showComment ? (
                            <>
                              <FloatingLabel controlId='floatingTextarea2' label={t('Comment')}>
                                <Form.Control
                                  as='textarea'
                                  placeholder={t('Tinggal-pesan')}
                                  style={{height: '100px'}}
                                  onChange={(e: any) => setComment(e.target.value)}
                                />
                              </FloatingLabel>
                            </>
                          ) : (
                            <p className='text-center fw-bold fs-4'>{t('Approve')}?</p>
                          )}
                        </Modal.Body>
                        <Modal.Footer>
                          <Button
                            className='btn btn-secondary me-2'
                            onClick={() => setShowApprove(false)}
                          >
                            {t('Tidak')}
                          </Button>
                          <Button
                            className='btn btn-success'
                            onClick={() => Approve()}
                            disabled={btnLoading}
                          >
                            {btnLoading ? (
                              <Spinner animation='border' variant='light' size='sm' />
                            ) : (
                              t('Ya')
                            )}
                          </Button>
                        </Modal.Footer>
                      </Modal>
                    </>
                  ) : (
                    <></>
                  )}
                </div>
              </div>
            )}
          </div>
        </>
      )}

      <Modal
        show={showCustomer}
        onHide={() => setShowCustomer(false)}
        centered
        backdrop='static'
        keyboard={false}
        size='lg'
      >
        <Modal.Header closeButton>
          <Modal.Title>{t('Browse')}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <TableBrowseCustomer
            values={fullCustomer}
            paginate={paginateNumber}
            numberUrls={numberURL}
            onSelected={(item) => {
              setCustomer(item.name)
              setCustomerID(item.customer_code)
              setTitleCustomer(item.title)
              setShowCustomer(false)
            }}
          />
        </Modal.Body>
      </Modal>

      <Modal
        show={showBank}
        onHide={() => setShowBank(false)}
        centered
        backdrop='static'
        keyboard={false}
        size='lg'
      >
        <Modal.Header closeButton>
          <Modal.Title>{t('Browse')}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <TableBrowseBankKey
            items={fullBankKey}
            paginate={paginateNumber2}
            numberUrls={numberURL2}
            onSelected={(item) => {
              setBankKey(item.bank_key)
              setBank(item.bank_name)
              setShowBank(false)
            }}
          />
        </Modal.Body>
      </Modal>

      <Modal
        show={showCommentCust}
        onHide={() => setShowCommentCust(false)}
        centered
        backdrop='static'
        size='lg'
        scrollable
      >
        <Modal.Header closeButton>
          <Modal.Title>{t('Chat')}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <FloatingLabel controlId='floatingTextarea2' label={t('Comment')}>
            <Form.Control
              as='textarea'
              id='areacomment'
              placeholder={t('Tinggal-pesan')}
              defaultValue={commentCust}
              style={{height: '100px'}}
              onChange={(e: any) => setTempComment(e.target.value)}
            />
          </FloatingLabel>
          <div className='d-flex justify-content-end'>
            <Button variant='primary' className='mt-3 mb-3' onClick={() => handlePostComment()}>
              {t('Tambah')}
            </Button>
          </div>
          {fullcomment?.length < 1 ? (
            ''
          ) : (
            <div className='table-responsive mt-10 bdr'>
              <table className='table table-row-dashed table-row-gray-300 align-middle gs-0 gy-4'>
                <thead>
                  <tr className='fw-bold w-100 align-items-center'>
                    <th className='td-3 text-center'>{t('no')}</th>
                    <th className='td-3 text-center'>{t('order-tanggal')}</th>
                    <th className='td-3 text-center'>{t('order-user')}</th>
                    <th className='td-3 text-center'>{t('Chat')}</th>
                  </tr>
                </thead>
                {fullcomment?.map((item: any, _index: number) => (
                  <tbody key={item?.id ?? _index}>
                    <tr className='w-100 align-items-center'>
                      <td className='td-150 text-center'>{_index + 1}</td>
                      <td className='td-150 text-center'>{item.created_at}</td>
                      <td className='td-150 text-center'>{item.user?.name}</td>
                      <td className='td-60 text-center'>
                        <div style={{textAlign: 'justify', padding: '0 0.775rem'}}>
                          {item.comment}
                        </div>
                      </td>
                    </tr>
                  </tbody>
                ))}
              </table>
              {/* End Table Head */}
            </div>
          )}
        </Modal.Body>
        {/* <Modal.Footer>
          <Button variant={status == 2 ? 'primary' : 'secondary'} onClick={() => setShowCommentCust(false)}>
            {status != 2 ? t("Cancel") : "Ok"}
          </Button>
        </Modal.Footer> */}
      </Modal>

      <Modal
        size='lg'
        show={showUpload}
        onHide={() => setShowUpload(false)}
        backdrop='static'
        keyboard={false}
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>{t('order-fileBox')}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Row>
            <Col sm={6}>
              <table className='mb-3'>
                <tr>
                  <td style={{width: '120px'}}>
                    <h6>{t('order-fileUnggah')}</h6>
                  </td>
                  <td className='w-75'
                    >
                    <InputFile
                          setFileName={setNamaFile}
                          setFiles={setFiles}
                          isBase64={false}
                      />
                  </td>
                </tr>
              </table>
              <table className='mb-3'>
                <tr>
                  <td style={{width: '120px'}}>
                    <h6>{t('order-keterangan')}</h6>
                  </td>
                  <td className='w-75'>
                    <Form.Control
                      type='text'
                      placeholder={t('order-keterangan')}
                      id='uploadketerangan'
                      onChange={(e: any) => setDescription(e.target.value)}
                    />
                  </td>
                </tr>
              </table>
              <table className='mb-3'>
                <tr>
                  <td>
                    <h6 className='me-11'>{t('Private')}</h6>
                  </td>
                  <td className='w-75 d-flex justify-content-start'>
                    <Form.Check
                      reverse
                      name='isPrivate'
                      type='checkbox'
                      className='mt-5 mb-2'
                      onClick={() => {
                        setIsPrivate(!isPrivate)
                      }}
                      id='isPrivate'
                    />
                  </td>
                </tr>
              </table>
              <table className='mb-3' hidden={isPrivate ? false : true}>
                <tr>
                  <td style={{width: '120px'}}>
                    <h6>{t('Akses Role')}</h6>
                  </td>
                  <td className='w-75' style={{maxWidth: '274px'}}>
                    <MultiSelect
                      key={isPrivate.toString()}
                      options={fullRole?.map((item: any) => {
                        return {label: item.label, value: item.value}
                      })}
                      value={tempRole}
                      onChange={(e: any) => setTempRole(e)}
                      labelledBy='Select'
                    />
                  </td>
                </tr>
              </table>
              <Button
                variant='primary'
                className='w-100'
                disabled={btnLoading}
                onClick={() => handleUpload(idItem)}
              >
                {btnLoading ? (
                  <Spinner animation='border' variant='light' size='sm' />
                ) : (
                  t('order-kirim')
                )}
              </Button>
            </Col>
            <div className='table-responsive mt-4' style={{marginTop: '3rem'}}>
              <table className='table table-row-dashed table-row-gray-300 align-middle gs-0 gy-4'>
                <thead className='border-bottom'>
                  <tr className=''>
                    <th className='text-center'>{t('order-noo')}</th>
                    <th className='text-center'>{t('order-keterangan')}</th>
                    <th className='text-center'>{t('order-tglUpload')}</th>
                    {/* <th className='text-center'>{t('User Code')}</th> */}
                    <th className='text-center'>{t('order-user')}</th>
                    <th className='text-center'>{t('Akses Role')}</th>
                    <th className='text-center'>{t('order-aksi')}</th>
                  </tr>
                </thead>
                {allFile.map((data: any, _index: any) => (
                  <tbody key={data?.id ?? _index}>
                    <tr className=''>
                      <td className='text-center'>
                        <label>{_index + 1}</label>
                      </td>
                      <td className='text-center'>
                        <label>{data.description}</label>
                      </td>
                      <td className='text-center'>
                        <label>{dateformat(data.updated_at)}</label>
                      </td>
                      {/* <td className='text-center'>
                        <label>{data.user?.customer_code || data.user?.nama_pengguna}</label>
                      </td> */}
                      <td className='text-center'>
                        {data.user?.customer != null ? (
                          <label>{data.user?.customer?.name}</label>
                        ) : (
                          <label>{data.user?.name}</label>
                        )}
                      </td>
                      <td className='text-center'>
                        {data.private ? (
                          data.roles.length > 0 ? (
                            <PopoverText
                              content={handleShowRoleName(data.roles)}
                              index={_index}
                              className='desc-slice'
                            />
                          ) : (
                            'Private'
                          )
                        ) : (
                          'Public'
                        )}
                      </td>
                      <td className='text-center'>
                        <button
                          className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1'
                          data-bs-toggle='tooltip'
                          data-bs-placement='top'
                          data-bs-trigger='hover'
                          title={t('unduh')}
                          onClick={() =>
                            handleDownloadAttachment(data.file_path)
                          }
                        >
                          <KTSVG
                            path='/media/icons/duotune/arrow-down-square-fill.svg'
                            className='svg-icon-3'
                          />
                        </button>
                        {(hakAkses?.attachment_delete ||
                          CheckSameIDAttachment(data.user_role_flag)) && (
                          <button
                            onClick={() => deleteAttachment(data.id)}
                            className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm'
                            data-bs-toggle='tooltip'
                            data-bs-placement='top'
                            data-bs-trigger='hover'
                            title={t('Hapus')}
                            hidden={roleUser != 'finance'}
                          >
                            <KTSVG
                              path='/media/icons/duotune/trash-fill.svg'
                              className='svg-icon-3'
                            />
                          </button>
                        )}
                      </td>
                    </tr>
                  </tbody>
                ))}
              </table>
            </div>
          </Row>
        </Modal.Body>
      </Modal>
    </>
  )
}

export {FinancialDetail}
